import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

import PropTypes from "prop-types";

// @mui/material components
import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Pool from "@mui/icons-material/Pool";
import SportsTennis from "@mui/icons-material/SportsTennis";
import LocalActivity from "@mui/icons-material/LocalActivity";
import DirectionsBus from "@mui/icons-material/DirectionsBus";
import Museum from "@mui/icons-material/Museum";
import SportsSoccer from "@mui/icons-material/SportsSoccer";
import Foundation from "@mui/icons-material/Foundation";
import FitnessCenter from "@mui/icons-material/FitnessCenter";
import FormatListNumbered from "@mui/icons-material/FormatListNumbered";
import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import NaturePeople from "@mui/icons-material/NaturePeople";
import CalendarMonthIcon from '@mui/icons-material/CalendarViewMonth';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Mouse from '@mui/icons-material/Mouse';
import Watch from '@mui/icons-material/Watch';

// core components
import Button from "../components/Button.jsx";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Alert } from '@mui/material';
import { Tooltip } from '@mui/material';
import Divider from '@mui/material/Divider';
import { Paper } from '@mui/material';
import { TextField, Switch, FormControlLabel} from '@mui/material';
import { green, grey, blue } from '@mui/material/colors';
import { Collapse } from '@mui/material';


import { TiposInstalacionReserva, PopUpResult, ResultadoReserva, Roles, OpcionSiNoStringLargo, TipoVisualizacionInstalaciones, OpcionesNominaciones, OpcionesAutorizaciones, DataStateModal, ModoModal, DialogOthelloResult, MessageOthelloBoxButtons, TipoExtraInstalaciones, TipoGraficoInstalaciones } from '../othelloConstantes.jsx';
import { GetDiaSemana, GetMes, getCurrentDataFormulario, getBotonPagarPasarelaPago } from '../othelloFunciones.jsx';

import OthelloEdit from '../componentsothello/OthelloEdit.jsx';
import OthelloTimer from '../componentsothello/OthelloTimer';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloCheckBox from '../componentsothello/OthelloCheckBox.jsx';
import OthelloTitulo from '../componentsothello/OthelloTitulo.jsx';
import OthelloPopUpResult from '../componentsothello/OthelloPopUpResult.jsx';
import OthelloModalBase from "../componentsothello/OthelloModalBase.jsx";

import OthelloFooter from '../componentsothello/OthelloFooter.jsx';

import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import Icon from "@mui/material/Icon";

export default function Reservar({ ...props })
{
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    const navigate = useNavigate();

    const { search } = useLocation();

    const [modoExterno, setModoExterno] = React.useState(false);    

    const [loading, setLoading] = React.useState(true);    
   
    const [loadingextras, setLoadingextras] = useState(false);    

    const [data, setdata] = React.useState(null);

    const [paso, setpaso] = React.useState(1);
    const [instalacion, setinstalacion] = React.useState(null);
    const [fecha, setfecha] = React.useState(null);
    const [tramo, settramo] = React.useState([]);
    const [plazas, setplazas] = React.useState(0);
    const [plazasReducidas, setplazasReducidas] = React.useState(0);
    const [plazasGratuitas, setplazasGratuitas] = React.useState(0);
    const [nominacionPax, setnominacionPax] = React.useState("");
    const [paxomitidos, setpaxomitidos] = useState([]);
    const [paxautoriza, setpaxautoriza] = React.useState(1);
    const [autorizaciones, setautorizaciones] = React.useState("");
    const [extraselected, setextraselected] = useState([]);
    const [numeroSocio, setNumeroSocio] = useState('');
    const [socioActivado, setsocioActivado] = useState(false);
    const [showCodigoDescuento, setShowCodigoDescuento] = useState(false);
    const [codigoDescuento, setCodigoDescuento] = useState('');
    const [errorCodigoDescuento, setErrorCodigoDescuento] = useState(false);

    const [infopago, setinfopago] = React.useState(null);
    const [tramosdispo, settramosdispo] = React.useState([]);    
    const [extrasdispo, setextrasdispo] = React.useState([]);
    const [alert, setalert] = React.useState(null);
    const [pagando, setpagando] = React.useState(false);
    const [errornominacion, seterrornominacion] = React.useState("");
    const [errorautorizacion, seterrorautorizacion] = React.useState("");
    const [errorDatosContactoObligatorios, setErrorDatosContactoObligatorios] = React.useState("");
    const [errorextras, seterrorextras] = React.useState("");    

    const [cantidadtramosfechadispo, setcantidadtramosfechadispo] = React.useState([]);
    const [loadingcantidadtramosfechadispo, setLoadingcantidadtramosfechadispo] = React.useState(false);

    const [statefechaModal, setstatefechaModal] = useState(DataStateModal.dsClosed);
    const [fechashowvisuali, setfechashowvisuali] = useState(null);
    const [fechamodalselected, setfechamodalselected] = useState(null);

    const [infoextraerror, setinfoextraerror] = useState("");
    

    var widthfilas = 60;
    var heightfilas = 45;

    const location = useLocation();

    React.useEffect(() => {

        getDataPageInstalacion();
    }, [loading]);


    const onClosePopUpResult = () => {
        setalert(null);
    }

    React.useEffect(() => {

        if (paso == 7) {
            getDispoExtrasInstalacion(fecha);
        }
        else if (paso == 2)
        {
            getDispoCantidadInstalacionTramosReserva(instalacion);
        }
    }, [paso]);

    const getDataPageInstalacion = () => {

        fetch('api/Data/GetInstalacionesUsuarioReserva')
            .then(response => response.json())
            .then(data => {

                if (data != null && (data.instalaciones != null || data.diaactual != null))
                    setdata(data);
                else {
                    setdata(null);
                    setinfoextraerror(data);
                }

                setLoading(false);
                setpaso(1);
                setinstalacion(null);
                setfecha(null);
                setinfopago(null);
                
                if (location.pathname.includes("ticket/booking"))
                    setModoExterno(true);
            });
    }

    const getDispoTramosInstalacion = (fecha) =>
    {
        if (instalacion != null && fecha != null)
        {
            var jsonData = JSON.stringify({ id_instalacion: instalacion.id_Instalacion, fecha: fecha });

            fetch('api/Data/GetTramosDisponibilidadInstalacion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                settramosdispo(res);
            }).catch(error => {
                settramosdispo([]);                
            });
        }
    }

    const getDispoCantidadInstalacionTramosReserva = (instala) => {

        try {
            if (instala != null) {
                let desdefecha = null;
                let hastafecha = null;

                if (instala.desde != null && instala.desde != "") {
                    let hoy = new Date();
                    hoy.setHours(0, 0, 0, 0); // Asegurar que solo comparamos fechas sin la hora

                    let fechaShowed = fechashowvisuali != null ? fechashowvisuali : (new Date(instala.desde) < hoy ? hoy : instala.desde);

                    let fechaDesde = new Date(instala.desde);
                    let fechaHasta = instala.abierto != null && instala != "" ? new Date(instala.abierto) : null;

                    let idOkfhasta = 0;

                    for (var i = 0; i <= 14; i++) {
                        let fechaGenerada = new Date(fechaShowed);
                        fechaGenerada.setDate(fechaGenerada.getDate() + i);

                        if (fechaGenerada >= fechaDesde && (!fechaHasta || fechaGenerada <= fechaHasta)) {
                            if (desdefecha == null) {
                                desdefecha = new Date(fechaShowed);
                                desdefecha.setDate(desdefecha.getDate() + i);
                            }

                            idOkfhasta = i;
                        }
                    }

                    hastafecha = new Date(fechaShowed);
                    hastafecha.setDate(hastafecha.getDate() + idOkfhasta + 1);
                }
                else {
                    desdefecha = new Date(data.diaactual);
                    hastafecha = new Date(data.diaactual);
                    hastafecha.setDate(hastafecha.getDate() + instala.diasAntelacion + 1);
                }

                if (desdefecha != null && hastafecha != null) {
                    setLoadingcantidadtramosfechadispo(true);

                    var jsonData = JSON.stringify({ id_instalacion: instala.id_Instalacion, desde: desdefecha, hasta: hastafecha });

                    fetch('api/Data/BusquedaDispoCantidadInstalacionTramosReserva', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: jsonData

                    }).then(response => response.json()).then(res => {
                        setcantidadtramosfechadispo(res);
                        setLoadingcantidadtramosfechadispo(false);
                    }).catch(error => {
                        setcantidadtramosfechadispo([]);
                        setLoadingcantidadtramosfechadispo(false);
                    });
                }
            }
        }
        catch (Exception)
        {
            if (loadingcantidadtramosfechadispo) {
                setLoadingcantidadtramosfechadispo(false);
                setcantidadtramosfechadispo([]);
            }            
        }
    }

    const getDispoExtrasInstalacion = (fecha) => {
        if (instalacion != null && fecha != null)
        {
            setLoadingextras(true);

            var jsonData = JSON.stringify({ id_instalacion: instalacion.id_Instalacion, fecha: fecha });

            fetch('api/Data/GetExtrasDisponibilidadInstalacion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                setextrasdispo(res);
                setLoadingextras(false);

                //SI no hay entonces paso al siguiente
                if (res != null && res.length == 0) {
                    setextraselected([]);
                    setpaso(8);
                }

            }).catch(error => {               
                setpaso(8);

                setextrasdispo(null);
                setLoadingextras(false);
            });
        }
    }

    const getTituloPasoExtras = () =>
    {
        //Si hay alguno 
        if (extrasdispo != null && extrasdispo.length > 0)
        {
            let HayEntradas = extrasdispo.some(x => x.tipoExtra == TipoExtraInstalaciones.Entradas);
            let HayExtrasNormales = extrasdispo.some(x => x.tipoExtra != TipoExtraInstalaciones.Entradas)


            if (HayEntradas && HayExtrasNormales)
                return "Entradas - Extras";
            else if (HayEntradas && !HayExtrasNormales)
                return "Entradas";
            else
                return "Extras";
        }
        else
            return "Extras";
    }

    const getTituloPaso = (paso, pasoactual, texto) => {
        if (paso == 1)
            return <Grid item xs={12}><OthelloTitulo titulo="Elija la actividad a reservar" backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;
        else if (paso == 2)
            return <Grid item xs={12}><OthelloTitulo titulo={"Selecciona una fecha - " + texto} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;
        else if (paso == 3)
            return <Grid item xs={12}><OthelloTitulo titulo={"Selecciona una franja horaria - " + getfechaformateada(texto)} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;
        else if (paso == 4)
            return <Grid item xs={12}><OthelloTitulo titulo="Selecciona las plazas a reservar" backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;
        else if (paso == 5)
            return <Grid item xs={12}><OthelloTitulo titulo={"Formulario"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;
        else if (paso == 6)           
            return <Grid item xs={12}><OthelloTitulo titulo={"Autorizaciones"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 7)
            return <Grid item xs={12}><OthelloTitulo titulo={getTituloPasoExtras()} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 8)             
            return <Grid item xs={12}><OthelloTitulo titulo={"Datos de la Reserva"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 9) 
            return <Grid item xs={12}><OthelloTitulo titulo={"Pago"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
    }

    const getTextoInstalacion = (instalacion, modo) => {
        if (instalacion != null) {
            if (modo == 1)
                return <Grid item xs={12} mt={1} ml={0}><p style={{ fontSize: 14 }} ><b>{TratarTexto(instalacion.infoUso)}</b></p></Grid>;
            else
                return <Grid item xs={12} mt={2} ml={0}><p style={{ fontSize: 12 }} ><b>{TratarTexto(instalacion.datosAdicionales)}</b></p></Grid>;
        }
        else
            return "";
    }

    const getNavegacionPaso = (onBack) => {
        return <MDBox
            sx={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'right',
                width: '100%',
                position: 'relative',
                marginTop: 0.5,
                paddingTop: 2,
                paddingBottom: 2,
                borderTop: '1px solid #e0e0e0',
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
                pr: 3
            }}
        >
            <Button color="secondary" onClick={onBack}>Volver</Button>
        </MDBox>        
    }

    function TratarTexto(infoshow) {
        if (!infoshow) return "";
        
        return (
            <MDBox
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    borderRadius: 2,
                    padding: 2,
                    mt: 1,
                    mb: 1,
                }}
            >
                <InfoOutlinedIcon sx={{ color: '#0ea5e9', mr: 1, mt: 0.5 }} />
                <MDTypography
                    variant="body2"
                    sx={{
                        color: '#374151',
                        lineHeight: 1.6,
                        whiteSpace: 'pre-line', // esto interpreta \n como saltos de línea
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: infoshow }} />
                </MDTypography>
            </MDBox>
        );
    }

    const getfechaformateada = (texto) => {
        let nuevafecha = new Date(texto);
        return GetDiaSemana(nuevafecha.getDay()) + " " + nuevafecha.getDate() + " " + GetMes(nuevafecha.getMonth()) + " " + nuevafecha.getUTCFullYear();
    }
    
    const getPrecioTramosExtrasSegunSituacion = (item, nuevoEstadoSocio) => {

        let PrecioFinal = item.precio;
        let EstadoFInalSocio = nuevoEstadoSocio != null ? nuevoEstadoSocio : socioActivado;

        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        if ((item.pax == null || (item.pax != null && item.pax<= 1 )) && EstadoFInalSocio && item.precioReducido > 0)
            PrecioFinal = item.precioReducido;

        return PrecioFinal;
    }

    const getResumenTotalesReservaSegunSituacion = () => {

        //GESTION DE PLAZAS
        //Ahora el numero de plaza
        var Normales = Number(plazas);
        var Reducidas = Number(plazasReducidas);
        var Gratuitas = Number(plazasGratuitas);

        //Obtengo las plazas
        var TotalPlazas = Normales + Reducidas + Gratuitas;

        //GESTION DE PRECIOS
        var precio = 0;
        var precioReducidas = 0;
        var precioExtras = 0;

        ////Obtenemos los precios de los tramos seleccionados
        if (tramo != null && tramo.length > 0) 
        {
            tramo.forEach(x => {
                //Si estamos en modo horario
                if (instalacion.tipo == TiposInstalacionReserva.Horaria)
                {
                    //si el precio es global no tengo que contar las plzas, directamente es el precio que le voy a cobrar
                    precio = precio + (x.esPrecioGlobal ? x.total : (plazas * x.total));
                    precioReducidas = precioReducidas + (plazasReducidas * x.precioReducido);
                }
                else {
                    precio = precio + (x.esPrecioGlobal ? x.precio : (plazas * x.precio));
                    precioReducidas = precioReducidas + (plazasReducidas * x.precioReducido);
                }
            });
        ////Obtenemos los precios de los tramos seleccionados
        //    tramo.forEach(x => {
        //        precio = precio + x.total;
        //        //precioReducidas = precioReducidas + (plazasReducidas * x.precioReducido);
        //    });
        }

        //Ahora sumamos los extras
        if (extraselected != null && extraselected.length > 0)
            extraselected.forEach(x => precioExtras = precioExtras + x.total);

        var TotalPrecio = precio + precioReducidas + precioExtras;

        //GESTION DE RESUMEN
        //Ahora hacemos el resumen de precios
        let conceptosResumenPrecio = [];
      
        let conceptoPrincipal = "Plazas Estandar (" + Normales + " pax)";

        if (TotalPlazas == 1)
            conceptoPrincipal = "Precio base";

        conceptosResumenPrecio.push({ descripcion: conceptoPrincipal, total: precio });

        if (Reducidas > 0 || Gratuitas > 0) {
            if (Reducidas > 0)
                conceptosResumenPrecio.push({ descripcion: "Plazas Reducidas (" + Reducidas + " pax)", total: precioReducidas });

            if (Gratuitas > 0)
                conceptosResumenPrecio.push({ descripcion: "Plazas Gratuitas (" + Gratuitas + "pax)", total: 0 });
        }

        if (extraselected != null && extraselected.length > 0)
            extraselected.forEach(x => conceptosResumenPrecio.push({ descripcion: x.concepto, total: x.total }));

        return {
            totalprecio: TotalPrecio, totalplazas: TotalPlazas, conceptosresumen: conceptosResumenPrecio
        }
    }

    const SetSituacionPreciosReserva = (nuevoEstadoSocio) => {

        //Debemos gestionar los precios de los tramos, ya que puede ser que ya no sean validos, bien porque se produce un descuento, o que se quita el mismo
        if (tramo != null && tramo.length > 0)
        {
            let tramosFInal = [];

            tramo.forEach(x =>
            {
                if (tramosdispo != null && tramosdispo.length > 0)
                {
                    let TramoSelected = tramosdispo.find(y => y.id_Tramo == x.id_Tramo);

                    if (TramoSelected != null) {

                        let PrecioFInal = getPrecioTramosExtrasSegunSituacion(TramoSelected, nuevoEstadoSocio);

                        x.precio = PrecioFInal;
                        x.total = PrecioFInal * x.cantidad;

                        tramosFInal.push({ ...x });                        
                    }                    
                   
                }
            });

            settramo(tramosFInal);
        }
    }
   
    //Sera multiseleccion si puede seleccion mas de un tramo
    const InstalacionPermiteMultiSeleccion = () => {
        return instalacion != null && instalacion.tramosDia > 1;
    }

    const TramoSelectedPermiteMultiSeleccion = (tramoselected) => {
        return instalacion != null && tramoselected != null && tramoselected.pax == 1 && tramoselected.maxPaxReservar == 1;
    }

    const InstalacionTieneSeleccionPax = () =>
    {
        if (instalacion != null && tramo != null && tramo.length > 0) {

            let tramoselected = null;

            if (tramosdispo != null && tramosdispo.length > 0)
                tramoselected = tramosdispo.find(y => y.id_Tramo == tramo[0].id_Tramo);

            return tramoselected != null && tramoselected.pax > 1 && tramoselected.maxPaxReservar >= 1;
        }
        else
            return false;
    }

    const InstalacionVisualiazacionGrafica = () => {
        return instalacion != null && (instalacion.tipoVisualizacion == TipoVisualizacionInstalaciones.Grafica || instalacion.tipoVisualizacion == TipoVisualizacionInstalaciones.GraficaPosiciones);
    }

    const InstalacionTieneNominacionDePax = () => {
        return instalacion != null && instalacion.nominarPax == 1 && instalacion.opcionesNominacion != null && instalacion.opcionesNominacion != "";
    }

    const InstalacionTieneAutorizaciones = () => {
        return instalacion != null && instalacion.activaAutorizaciones == 1;
    }

    const InstalacionOcultarCampoNumSocio = () => {
        return instalacion.literalCampoNumSocio != null && instalacion.literalCampoNumSocio != "" && instalacion.literalCampoNumSocio == "hidden";
    }

    const EsFechaValidaEnFiltrosFechasInstalacion = (FechaComprobar) =>
    {
        if (instalacion != null)
        {            
            if (instalacion.filtroFechasInstalacion != null && instalacion.filtroFechasInstalacion.trim() !== "")
            {
                try
                {
                    let fechasFiltro = instalacion.filtroFechasInstalacion.split("|");

                    if (fechasFiltro != null && fechasFiltro.length>0)
                    {
                        let fechaBase = new Date(FechaComprobar);
                        fechaBase.setHours(0, 0, 0, 0);

                        for (let i = 0; i < fechasFiltro.length; i++)
                        {
                            try {
                                let partes = fechasFiltro[i].trim().split("/");
                                if (partes.length === 3) {
                                    let fechaFiltro = new Date(
                                        parseInt(partes[2], 10),
                                        parseInt(partes[1], 10) - 1,
                                        parseInt(partes[0], 10)
                                    );
                                    fechaFiltro.setHours(0, 0, 0, 0);

                                    if (fechaFiltro.getTime() === fechaBase.getTime()) {
                                        return true; // La fecha coincide con una del filtro
                                    }
                                }
                            }
                            catch
                            { }
                        }

                        return false; // No se encontró la fecha
                    }
                    else
                        return true;
                }
                catch
                {
                    return true;
                }

            }
            else
                return true;
        }
        else
            return true;

    }

    const pasoAtras = () => {
        if (paso == 2) {
            setpaso(1);
            setinstalacion(null);
        }
        else if (paso == 3)
        {
            if (instalacion.tipo == TiposInstalacionReserva.Horaria)
                setpaso(1);
            else
                setpaso(2);
            setfecha(null);
            settramo(null);
        }
        else if (paso == 4) {
            setpaso(3);
            settramo(null);            
        }
        //Si estamos en el nominar pax
        else if (paso == 5)
        {
            //Si tiene seleccion de pax entonces 
            if (InstalacionTieneSeleccionPax()) {
                setpaso(4);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else
            {
                setpaso(3);
                settramo(null);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
        }
        //si estmos en la opcion de autorizacion
        else if (paso == 6) {
            if (InstalacionTieneNominacionDePax()) {
                setpaso(5);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else if (InstalacionTieneSeleccionPax()) {
                setpaso(4);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else {
                setpaso(3);
                settramo(null);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
        }
        //si estamos en extras
        else if (paso == 7)
        {
            if (InstalacionTieneAutorizaciones())
            {
                setpaso(6);
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else if (InstalacionTieneNominacionDePax()) {
                setpaso(5);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else if (InstalacionTieneSeleccionPax()) {
                setpaso(4);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else {
                setpaso(3);
                settramo(null);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
        }
        //si estamos en la zona de los datos de la reservar
        else if (paso == 8)
        {
            if (extrasdispo != null && extrasdispo.length > 0) {
                setpaso(7);
                setextraselected([]);
            }
            else if (InstalacionTieneAutorizaciones()) {
                setpaso(6);
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else if (InstalacionTieneNominacionDePax()) {
                setpaso(5);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else if (InstalacionTieneSeleccionPax()) {
                setpaso(4);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
            else {
                setpaso(3);
                settramo(null);
                setplazas(0);
                setplazasReducidas(0);
                setplazasGratuitas(0);
                setnominacionPax("");
                setpaxautoriza(1);
                setautorizaciones("");
            }
        }
    }

    const onClickInstalacion = (opc) => {
        if (opc != null && paso == 1)
        {
            setpaso(2);
            setinstalacion(opc);
        }            
    }

    const onClickFechaReserva = (fecha) => {
        if (fecha != null && paso == 2) {
            getDispoTramosInstalacion(fecha);
            setpaso(3);
            setfecha(fecha);            
        }
    }

    const onClickTramoReserva = (tramoselected, cantfinal) => {
        if (tramoselected != null && paso == 3)
        {
            if (tramo != null)
            {                
                if (tramo.some(x => x.id_Tramo == tramoselected.id_Tramo)) {
                    var array = [];

                    tramo.forEach(x => {
                        if (x.id_Tramo != tramoselected.id_Tramo)
                            array.push(x);

                    });
                    settramo(array);
                }
                else {
                    //si ha ya el maximo numero de tramos en dicho dia no permitimos seleccionar mas
                    if (tramo.length < instalacion.tramosDia || instalacion.tipo == TiposInstalacionReserva.Horaria)
                    {
                        //Obtengo el precio final
                        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(tramoselected);

                        var array = instalacion.tipo == TiposInstalacionReserva.Horaria ? [] : [...tramo];
                        array.push({
                            id_Tramo: tramoselected.id_Tramo, descripcion: tramoselected.descripcion, cantidad: cantfinal, precio: PrecioFinal, total: PrecioFinal * cantfinal, precioReducido: tramoselected.precioReducido, precioHora: tramoselected.precioHora,
                            itemsHoraria: tramoselected.itemsHoraria, periocidadHoraria: tramoselected.periocidadHoraria, item24horas: tramoselected.item24horas, opcionAnyHora: tramoselected.opcionAnyHora, esPrecioGlobal : tramoselected.esPrecioGlobal
                        });

                        settramo(array);
                    }
                }
            }
            else
            {
                //Obtengo el precio final
                let PrecioFinal = getPrecioTramosExtrasSegunSituacion(tramoselected);
               
                var array = [];
                array.push({
                    id_Tramo: tramoselected.id_Tramo, descripcion: tramoselected.descripcion, cantidad: cantfinal, precio: PrecioFinal, total: PrecioFinal * cantfinal, precioReducido: tramoselected.precioReducido, precioHora: tramoselected.precioHora,
                    itemsHoraria: tramoselected.itemsHoraria, periocidadHoraria: tramoselected.periocidadHoraria, item24horas: tramoselected.item24horas, opcionAnyHora: tramoselected.opcionAnyHora, esPrecioGlobal: tramoselected.esPrecioGlobal });

                settramo(array);
            }

            //SI la instalacion no permite multiseleccion, o el tramo seleccionado no lo permite, entonces provocamos el click
            if (!InstalacionPermiteMultiSeleccion() || !TramoSelectedPermiteMultiSeleccion(tramoselected)) {
                onClickTramoContinuar(tramoselected);
            }         
        }
    }

    const onClickHorarioTramoReserva = (horas, precioFinal) =>
    {

        if (tramo != null && tramo.length > 0 && paso == 3)
        {
            var array = [...tramo];

            array.forEach(x =>
            {
                let tramoselected = null;

                if (tramosdispo != null && tramosdispo.length > 0)
                    tramoselected = tramosdispo.find(y => y.id_Tramo == x.id_Tramo);

                x.horas = horas;
                x.cantidad = 1;                
                x.total = precioFinal
                x.descripcion = tramoselected.descripcion + " ("+horas+" horas)"
            })

            settramo(array);
        }
    }

    const onClickTramoContinuar = (tramoselected) =>
    {
        //Si el tramo nos indica que tiene seleccion de personas
        if (tramoselected.pax > 1 && tramoselected.maxPaxReservar >= 1) {
            setpaso(4);            
        }
        //si no hay que selecciona plaza pero si que debemos nominar las pax
        else if (InstalacionTieneNominacionDePax()) {
            setpaso(5);           
            setplazas(1);
            setplazasReducidas(0);
            setplazasGratuitas(0);
        }
        //sino, si no hay nominar pero si autorizaciones
        else if (InstalacionTieneAutorizaciones())
        {
            setpaso(6);
            setplazas(1);
            setplazasReducidas(0);
            setplazasGratuitas(0);
            setnominacionPax("");
        }
        //Sino, debemos saltarnos dicho paso
        else
        {            
            setpaso(7);            
            setplazas(1);
            setplazasReducidas(0);
            setplazasGratuitas(0);
            setnominacionPax("");
            setautorizaciones("")
        }
    }

    const onClickPlazasReserva = (maxplazas) => {
        var cbplaza = document.getElementById('plazas');
        var cbplazaReducidas = document.getElementById('plazasReducidas');
        var cbplazasGratuitas = document.getElementById('plazasGratuitas');

        var estandar = cbplaza != null ? Number(cbplaza.value) : 0;
        var reducidas = cbplazaReducidas != null ? Number(cbplazaReducidas.value) : 0;
        var gratuitas = cbplazasGratuitas != null ? Number(cbplazasGratuitas.value) : 0;

        var TotalPlazas = estandar + reducidas + gratuitas;

        if (cbplaza != null && cbplaza.value > 0 && paso == 4 && maxplazas >= TotalPlazas) {

            var pasoSiguiente = -1;

            if (InstalacionTieneNominacionDePax())
                pasoSiguiente = 5;
            else if (InstalacionTieneAutorizaciones())
                pasoSiguiente = 6;
            else
                pasoSiguiente = 7;
            
            setpaso(pasoSiguiente);            
            setplazas(estandar);
            setplazasReducidas(reducidas);
            setplazasGratuitas(gratuitas);            
        }
    }

    const onClickNominadasPlazasReserva = () => {

        let formulario = document.getElementById('formnominacionpax');
        let formData = new FormData(formulario);
        let dtanomi = "";

        formData.forEach((value, key) => {
            dtanomi += key + '=' + value + '|';
        });

        var jsonData = JSON.stringify(dtanomi);

        fetch('api/Data/ComprobarDatosNominacionPax', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            if (res != null) {
                if (res.ok)
                {
                    if (InstalacionTieneAutorizaciones())
                        setpaso(6);
                    else
                        setpaso(7);
                    setnominacionPax(dtanomi);
                    seterrornominacion("");
                }
                else {
                    seterrornominacion(res.exception);                    
                }
            }
            else
                seterrornominacion("Se ha producido al comprobar lo datos, intentelo mas tarde");

        }).catch(error => {
            seterrornominacion(error);            
        });
    }

    const OnCheckedChangeOmitirPax = (id, checked) =>
    {
        if (checked) {
            //Si no esta dentro de los omitidos lo añado
            if (paxomitidos == null || (paxomitidos != null && !paxomitidos.some(x => x == id))) {
                var array = [];

                if (paxomitidos != null)
                    array = [...paxomitidos];

                array.push(id);

                setpaxomitidos(array);                
            }
        }
        //Si indico que false
        else {
            if (paxomitidos != null && paxomitidos.some(x => x == id)) {
                var array = [...paxomitidos]; // make a separate copy of the array

                var index = array.indexOf(id);

                //Elimino el de index concreto
                array.splice(index, 1);

                //Modificao el estado de data para que refresque la pantalla
                setpaxomitidos(array);                
            }
        }
    }

    const onClickSeleccionaFecha = () => {

        setstatefechaModal(DataStateModal.dsOpen);
    }

    const OnChangeFechaModal = (valor) => {
        if (valor != null)
            setfechamodalselected(valor);
    }

    const othelloModalResulFecha = (modo, result, valor) => {

        if (result == DialogOthelloResult.OK) {
            setstatefechaModal(DataStateModal.dsClosed);

            let fechaShowed = fechamodalselected != null ? fechamodalselected : fechashowvisuali;

            setfechashowvisuali(fechaShowed);          

            if (fechamodalselected != null)
                setfechamodalselected(null);
        }
        else {
            setstatefechaModal(DataStateModal.dsClosed);

            if (fechamodalselected != null)
                setfechamodalselected(null);
        }
    }

    const onClickAddAutorizacion = () => {
        setpaxautoriza(paxautoriza + 1);
    }

    const onClickDeleteAutorizacion = () => {
        setpaxautoriza(paxautoriza - 1);
    }

    const onClickAutorizaciones = () => {

        let formulario = document.getElementById('formautorizacion');
        let formData = new FormData(formulario);
        let dtaauto = "";

        formData.forEach((value, key) => {
            dtaauto += key + '=' + value + '|';
        });

        var jsonData = JSON.stringify(dtaauto);

        fetch('api/Data/ComprobarDatosAutorizacion', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            if (res != null) {
                if (res.ok) {
                    setpaso(7);
                    setautorizaciones(dtaauto);
                    seterrorautorizacion("");
                }
                else {
                    seterrorautorizacion(res.exception);
                }
            }
            else
                seterrorautorizacion("Se ha producido al comprobar lo datos, intentelo mas tarde");

        }).catch(error => {
            seterrorautorizacion(error);
        });
    }    

    const handleAddExtraReserva = (item) =>
    {
        let extrasNuevo = [...extraselected];

        if (extraselected.some(x => x.id_Extra == item.id_Extra))
            extrasNuevo = extrasNuevo.filter(x => x.id_Extra != item.id_Extra);

        let combocantidad = document.getElementById("cantidad" + item.id_Extra);
        var cantfinal = Number(combocantidad != null ? combocantidad.value : 1);

        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(item);

        extrasNuevo.push({ id_Extra: item.id_Extra, cantidad: cantfinal, precio: PrecioFinal, total: PrecioFinal * cantfinal, concepto: item.descripcion });

        setextraselected(extrasNuevo);
    };

    const handleEliminarExtraReserva = (item) => {
        let extrasNuevo = [...extraselected];

        if (extraselected.some(x => x.id_Extra == item.id_Extra))
            extrasNuevo = extrasNuevo.filter(x => x.id_Extra != item.id_Extra);

        setextraselected(extrasNuevo);
    };

    const onClickAceptarExtras = () => {


        //Si hay alguno 
        if (extrasdispo != null && extrasdispo.length > 0) {
            let HayEntradas = extrasdispo.some(x => x.tipoExtra === TipoExtraInstalaciones.Entradas);

            if (HayEntradas) {
                let numEntradas = 0;

                extraselected.forEach(x => {
                    let extra = extrasdispo.find(item => x.id_Extra === item.id_Extra);

                    //si el extra que estamos tratando es entrada
                    if (extra != null && extra.tipoExtra === TipoExtraInstalaciones.Entradas)
                        numEntradas += x.cantidad;
                });

                var Normales = Number(plazas);
                var Reducidas = Number(plazasReducidas);
                var Gratuitas = Number(plazasGratuitas);

                //Obtengo las plazas
                var TotalPlazas = Normales + Reducidas + Gratuitas;

                let EntradasValidas = numEntradas >= TotalPlazas;

                if (EntradasValidas)
                {
                    if (errorextras != null && errorextras != "")
                        seterrorextras("")

                    setpaso(8);
                }
                else
                    seterrorextras("Debe seleccionar el mismo numero de entradas o mas que el numero de plazas reservadas")
            }
            else
                setpaso(8);
        }
        else {
            if (errorextras != null && errorextras != "")
                seterrorextras("")

            setpaso(8);
        }
    }

    const handleChangeNumero = (event) => {
        setNumeroSocio(event.target.value);
    };

    const handleToggle = () => {
        if (numeroSocio.trim() !== '')
        {
            setsocioActivado(!socioActivado);

            SetSituacionPreciosReserva(!socioActivado);

            setextraselected([]);
        }
    };

    const handleAplicarCodigoDescuento = () => {
        // Simula validación del código (puedes conectar esto con lógica real)
        if (codigoDescuento.trim().toLowerCase() !== 'opera2025') {
            setErrorCodigoDescuento(true);
        } else {
            setErrorCodigoDescuento(false);
            // Aplica el descuento aquí
        }
    };

    const grabarReserva = () => {

        //Obtengo los datos
        let formulario = document.getElementById('formreserva');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        let errorDatosContacto = "";

        //Si los datos son obligatorios o estamos en modo externo (ya que en modo externo no esta logado)
        if (instalacion.obligatorioTodosDatosContacto == 1 || modoExterno)
        {
            let datosFormulario = getCurrentDataFormulario(formulario);

            if (datosFormulario.Contacto != "" && datosFormulario.EMail != "" && datosFormulario.Telefono != "" && (InstalacionOcultarCampoNumSocio() || (!InstalacionOcultarCampoNumSocio() && datosFormulario.NumSocio != "") ))
                 errorDatosContacto = "";
            else
                errorDatosContacto = "Debe rellenar todos los datos de contacto para poder reserva";                
        }        

        if (errorDatosContacto != "") {
            setErrorDatosContactoObligatorios(errorDatosContacto);
        }
        else {
            fetch('api/Data/GrabarReserva', {
                method: 'POST',
                body: formData,

            }).then(response => response.json()).then(res => {

                if (res != null && res.ok) {
                    if (res.resultado == ResultadoReserva.OkAFaltaDePago) {
                        setpaso(9);
                        setinfopago(res.infopago);
                    }
                    else {
                        setalert(PopUpResult.OK);
                        setLoading(false);
                        setpaso(1);
                        setinstalacion(null);
                        setfecha(null);
                        settramo(null);
                        setplazas(0);
                        setplazasReducidas(0);
                        setplazasGratuitas(0);
                        setinfopago(null);
                    }
                }
                else
                    setalert(PopUpResult.KO);

                if (props != null && props.onResultReserva != null && res.resultado != ResultadoReserva.OkAFaltaDePago)
                {
                    let errorShow = res.resultado == ResultadoReserva.ErrorException && res.exception != null && res.exception != "" ? res.exception : res.resultado;

                    props.onResultReserva(res != null && res.ok ? PopUpResult.OK : PopUpResult.KO, errorShow);
                }

            }).catch(error => {
                setalert(PopUpResult.KO);

                if (props != null && props.onResultReserva != null)
                    props.onResultReserva(PopUpResult.KO, error)
            });
        }
    }

    const realizarPago = (event) => {
        setpagando(true);
    }

    const doPagoPaytef = (event, data) => {

        event.preventDefault();

        if (data != null && data.urlParametrosPaytef != null && data.urlParametrosPaytef != "")
        {
            setpagando(true);
            let continuar = true;           

            if (continuar) {
                fetch('/api/Data/GetOrderPaytef', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: data.urlParametrosPaytef

                }).then(response => response.json()).then(res => {

                    if (res != null && res.ok) {
                        //Si se ha recibido un ok
                        if (res.resultado == ResultadoReserva.OkAFaltaDePago) {
                            window.location.href = res.infopago.urlOrderPaytef;
                            // window.open(res.urlOrderViva, '_blank', 'noopener noreferrer');
                            //window.location.assign(res.urlOrderViva);
                        }
                        else if (res.resultado == ResultadoReserva.ErrorException && res.exceptionMessage != null && res.exceptionMessage != "") {
                            setpagando(false);
                            //      seterrorvalidacionform(res.exceptionMessage);
                            setalert(PopUpResult.KO);

                            if (props != null && props.onResultReserva != null && res.resultado != ResultadoReserva.OkAFaltaDePago)
                                props.onResultReserva(res != null && res.ok ? PopUpResult.OK : PopUpResult.KO, res.exceptionMessage)
                        }
                    }
                    else {
                        setpagando(false);
                        setalert(PopUpResult.KO);
                    }
                }).catch(error =>
                {
                    setpagando(false);
                    setalert(PopUpResult.KO);

                    if (props != null && props.onResultReserva != null)
                        props.onResultReserva(PopUpResult.KO, error)
                });
            }
            else
            {
                setpagando(false);
                //seterrorvalidacionform("Error datos del formualrio");
            }
        }
        else {
            setpagando(false);
            //seterrorvalidacionform("Error datos del formualrio");
        }
    }

    function renderGetIcono(tipo) {

        if (tipo == TiposInstalacionReserva.Piscina)
            return <Pool fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Tenis)
            return <SportsTennis  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Padel)
            return <SportsTennis  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Evento)
            return <LocalActivity  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Excursiones)
            return <DirectionsBus  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Museo)
            return <Museum  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Futbol)
            return <SportsSoccer  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Polideportivo)
            return <Foundation  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Fronton)
            return <SportsTennis  fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Gimnasio)
            return <FitnessCenter fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Inscripcion)
            return <FormatListNumbered fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Parque)
            return <NaturePeople fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Horaria)
            return <Watch fontSize="large" />
        else if (tipo == -1)
            return <PhotoCamera fontSize="large" />
        else
            return "";
    }

    function renderInstalacion(item)
    {
        const hasImage = item?.image && item.image.trim() !== "";

        return (
            <Grid item xs={12} md={6} lg={3}>
                <MDBox m={1}>
                    <Card
                        onClick={() => onClickInstalacion(item)}
                        sx={{
                            display: 'flex',
                            height: 150,
                            borderRadius: 3,
                            overflow: 'hidden',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <MDBox display="flex" alignItems="center">
                        {/* Imagen o ícono lateral */}
                        <MDBox
                            sx={{
                                width: '40%',
                                minHeight: 150,
                                backgroundImage: hasImage ? `url(${item.image})` : 'none',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundColor: hasImage ? 'transparent' : '#f0f0f0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {!hasImage && renderGetIcono(item.tipo)}
                        </MDBox>

                        {/* Contenido derecho */}
                        <MDBox
                            sx={{
                                width: '60%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                px: 2,
                                py: 1.5,
                                backgroundColor: '#ffffff', // aseguramos fondo claro
                            }}
                        >
                            <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                textTransform="capitalize"
                                sx={{
                                    mb: 0.5,
                                    color: '#111827', // texto oscuro siempre
                                }}
                            >
                                {item.codigo}
                            </MDTypography>

                            <MDTypography
                                variant="body2"
                                sx={{
                                    fontSize: 14,
                                    color: '#4b5563', // gris moderno
                                }}
                            >
                                {item.descripcion}
                            </MDTypography>
                            </MDBox>
                        </MDBox>
                    </Card>
                </MDBox>
            </Grid>
        );         
    }

    function renderInstalaciones(dato) {

        let finales = dato != null && dato.instalaciones != null && dato.instalaciones.length > 0 ? dato.instalaciones.map(x => renderInstalacion(x)) : "";

        return finales;
    }
   
    function renderSeleccionFecha(i, diainicio) {
        let nuevafecha = new Date(diainicio);
        nuevafecha.setDate(nuevafecha.getDate() + i);

        let day = nuevafecha.toDateString();

        let abiertofecha = new Date(instalacion.abierto);
        let dayabiertofecha = abiertofecha.toDateString();

        let haydisposeguro = false;
        let todosTramosCerrado = false;
        let diaentero = nuevafecha.getDay();
        let dialasemans = "";

        if (diaentero == 0)
            dialasemans = "D";
        else if (diaentero == 1)
            dialasemans = "L";
        else if (diaentero == 2)
            dialasemans = "M";
        else if (diaentero == 3)
            dialasemans = "X";
        else if (diaentero == 4)
            dialasemans = "J";
        else if (diaentero == 5)
            dialasemans = "V";
        else if (diaentero == 6)
            dialasemans = "S";

        if (instalacion != null && instalacion.diasTodosTramosCerrados != null && instalacion.diasTodosTramosCerrados.length > 0 && instalacion.diasTodosTramosCerrados.some(x => x == dialasemans))
            todosTramosCerrado = true;

        if (cantidadtramosfechadispo != null && cantidadtramosfechadispo.length > 0) {

            let ExisteCantidad = cantidadtramosfechadispo.find(x => new Date(x.fecha).toDateString() === nuevafecha.toDateString());

            if (ExisteCantidad != null)
                haydisposeguro = ExisteCantidad.cantidadDisponible != null && ExisteCantidad.cantidadDisponible > 0;
        }

        //Si estamos en una instalacion cualquiera o la fecha que estamos tratabdo es justo la del evento
        if ((instalacion.tipo != TiposInstalacionReserva.Evento && instalacion.tipo != TiposInstalacionReserva.Excursiones && instalacion.tipo != TiposInstalacionReserva.Inscripcion && !todosTramosCerrado) ||
            ((instalacion.tipo == TiposInstalacionReserva.Evento || instalacion.tipo == TiposInstalacionReserva.Excursiones || instalacion.tipo == TiposInstalacionReserva.Inscripcion) && dayabiertofecha == day && !todosTramosCerrado))
        {
            //si es instalacion horaria pulsamos directamente la fecha, para que no la tenga ni que seleccionar
            if (instalacion.tipo == TiposInstalacionReserva.Horaria)
                onClickFechaReserva(day);

            return <MDBox m={0.5}>
                <Card
                    onClick={() => onClickFechaReserva(day)}
                    sx={{
                        cursor: 'pointer',
                        borderRadius: 3,
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <MDBox
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 2,
                            p: 2,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        {/* Icono circular */}
                        <MDBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                backgroundColor: 'secondary.main',
                                color: 'white',
                                borderRadius: '50%',
                                width: '2.5rem',
                                height: '2.5rem',
                                mb: 1,
                            }}
                        >
                            <Icon fontSize="small">today</Icon>
                        </MDBox>

                        {/* Día de la semana */}
                        <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ color: '#111827', mb: 0.5 }}
                        >
                            {GetDiaSemana(nuevafecha.getDay())}
                        </MDTypography>

                        {/* Fecha completa */}
                        <MDTypography
                            variant="caption"
                            sx={{ fontSize: 13, color: '#6B7280' }}
                        >
                            {nuevafecha.getDate()} {GetMes(nuevafecha.getMonth())} {nuevafecha.getUTCFullYear()}
                        </MDTypography>
                        {haydisposeguro ? <CheckCircleIcon style={{ fontSize: 14, color: '#10B981', marginTop: 2 }} /> : <Mouse style={{ fontSize: 14, color: '#9CA3AF', marginTop: 2 }}/> }
                    </MDBox>
                </Card>
            </MDBox>
        }        
        else
            return "";
    }

    function renderSeleccionFechas() 
    {
        var fechasfinal = [];

        if (instalacion != null)
        {              
            if (instalacion.desde != null && instalacion.desde != "")
            {
                let hoy = new Date();
                hoy.setHours(0, 0, 0, 0); // Asegurar que solo comparamos fechas sin la hora
                
                let fechaShowed = fechashowvisuali != null ? fechashowvisuali : (new Date(instalacion.desde) < hoy ? hoy : instalacion.desde);

                let fechaDesde = new Date(instalacion.desde);
                let fechaHasta = instalacion.abierto != null && instalacion != "" ? new Date(instalacion.abierto) : null;

                //si estamos con horario, debemos ver si la fecha esta dentro de la fechas en las que se puede reservar
                if (instalacion.tipo == TiposInstalacionReserva.Horaria)
                {
                    if (EsFechaValidaEnFiltrosFechasInstalacion(hoy))
                    {
                        //si la fecha actual esta dentro de los parametros validos
                        if (hoy >= fechaDesde && (!fechaHasta || hoy <= fechaHasta)) {

                            let datafecha = renderSeleccionFecha(0, hoy);

                            if (datafecha != "")
                                fechasfinal.push(datafecha);
                        }
                    }
                }
                else {
                    for (var i = 0; i <= 14; i++)
                    {
                        let fechaGenerada = new Date(fechaShowed);
                        fechaGenerada.setDate(fechaGenerada.getDate() + i);

                        if (EsFechaValidaEnFiltrosFechasInstalacion(fechaGenerada)) {
                            if (fechaGenerada >= fechaDesde && (!fechaHasta || fechaGenerada <= fechaHasta)) {
                                let datafecha = renderSeleccionFecha(i, fechaShowed);

                                if (datafecha != "")
                                    fechasfinal.push(datafecha);
                            }
                        }
                    }
                }
            }
            else
            {
                //si no tenemos desde, los dias de antelacion en horaria no tiene sentido porque el dia actual siempre dejara
                if (instalacion.tipo == TiposInstalacionReserva.Horaria)
                {
                    if (EsFechaValidaEnFiltrosFechasInstalacion(data.diaactual))
                    {
                        let datafecha = renderSeleccionFecha(0, data.diaactual);

                        if (datafecha != "")
                            fechasfinal.push(datafecha);
                    }
                }
                else
                {
                    for (var i = 0; i <= instalacion.diasAntelacion; i++)
                    {
                        let fechaGenerada = new Date(data.diaactual);
                        fechaGenerada.setDate(fechaGenerada.getDate() + i);

                        if (EsFechaValidaEnFiltrosFechasInstalacion(fechaGenerada))
                        {
                            let datafecha = renderSeleccionFecha(i, data.diaactual);

                            if (datafecha != "")
                                fechasfinal.push(datafecha);
                        }
                    }
                }
            }
        }

        //version 2
        //return fechasfinal != null && fechasfinal.length > 0 ? fechasfinal : <Grid item xs={12} sm={6} md={3}><h2 style={{ color: '#eb4034' }}>No existen fechas disponibles</h2></Grid>;
        let tituloReserva = "";
       
        const opcionesFecha = { day: "2-digit", month: "long", year: "numeric" };

        if (instalacion.desde && instalacion.abierto) {
            let titulo = `Reserva disponible desde ${new Date(instalacion.desde).toLocaleDateString("es-ES", opcionesFecha)} hasta ${new Date(instalacion.abierto).toLocaleDateString("es-ES", opcionesFecha)}`;


            tituloReserva = (<MDBox
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#e0f2fe', // azul claro (info)
                    color: '#0369a1', // azul fuerte
                    padding: 2,
                    borderRadius: 2,
                    mb: 3,
                }}
            >
                <CalendarMonthIcon sx={{ mr: 1 }} />
                <MDTypography variant="subtitle1" fontWeight="medium">
                    {titulo}
                </MDTypography>
            </MDBox>);
        }

        return (
            <MDBox width="100%" textAlign="center" p={2}>
                {tituloReserva}
                {fechasfinal && fechasfinal.length > 0 ? (
                    <MDBox
                        sx={{
                            display: 'flex',
                            overflowX: 'auto',
                            gap: 2,
                            py: 1,
                            px: 1,
                            scrollSnapType: 'x mandatory',
                            '&::-webkit-scrollbar': { display: 'none' }, // Oculta scrollbar en navegadores compatibles
                        }}
                    >
                        {fechasfinal.map((fechaComponent, index) => (
                            <MDBox key={index} sx={{ flex: '0 0 auto', scrollSnapAlign: 'start' }}>
                                {fechaComponent}
                            </MDBox>
                        ))}
                    </MDBox>
                ) : (<MDBox mt={2}>
                            <Alert
                                severity="error"
                                variant="outlined"
                                sx={{
                                    fontSize: "0.9rem",
                                    color: "error.main",
                                    borderColor: "error.light",
                                    backgroundColor: "#fff8e1",
                                    paddingY: 1,
                                    paddingX: 2,
                                    alignItems: "center"
                                }}
                            >
                                    No existen fechas disponibles
                            </Alert>
                        </MDBox>
                     )}

                {instalacion.desde ? (
                    <Grid container justifyContent="center" mt={2}>
                        <Grid item xs={12} >
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={() => onClickSeleccionaFecha()}
                                sx={{ borderRadius: 2, textTransform: 'none' }}
                            >
                                Buscar Fecha
                            </Button>
                        </Grid>
                    </Grid>
                ) : null}
                {loadingcantidadtramosfechadispo ? <CircularProgress size = {12} sx = {{ color: '#9CA3AF', mt: 0.5 }} /> : "" }
            </MDBox>
        );
    }

    function renderSelecionTramo(item)
    {
        let disable = item.cantidadDisponible <= 0;
       
        let shadow = true;
        
        let PrecioInicial = 0;
        let PrecioFinal = item.precio;
        //Si solo hay una plaza el precio estara disabled, ya que es amodo de que el cliente vea el descuento por ser socio
        let PrecioInicialDisabled = item.pax <= 1;

        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        if ((socioActivado || item.pax > 1) && item.precioReducido > 0) {
            PrecioInicial = item.precio;
            PrecioFinal = item.precioReducido;
        }             

        {/* Si tiene seleccion de pax entonces pongo cero , porque hasta que no me indique personas no puedo calcular precios, pero si es solo una plaza entonces directamente */ }
        return <Grid item xs={12} md={6} lg={3}>
            <MDBox m={0}>                
                <Card                   
                    onClick={disable ? null : () => onClickTramoReserva(item, item.pax > 1 ? 0 : 1)}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        px: 3,
                        py: 2,
                        boxShadow: (theme) => (shadow ? theme.boxShadows.lg : 'none'),
                        border: tramo?.some(x => x.id_Tramo === item.id_Tramo)
                            ? '2px solid #1a73e8'
                            : '1px solid #e0e0e0',
                        borderRadius: 2,
                        cursor: disable ? 'not-allowed' : 'pointer',
                        opacity: disable ? 0.5 : 1,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            boxShadow: disable ? 'none' : 12,
                            transform: disable ? 'none' : 'scale(1.01)',
                        },
                    }}
                >
                    {/* Hora con borde a la derecha */}
                    <MDBox
                        minWidth="80px"
                        pr={0}
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        sx={{
                            borderRight: '1px solid #ccc',
                        }}
                        mt={1}
                    >
                        <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                            {item.horainistring}
                        </MDTypography>
                        <MDTypography variant="body2" color="text.primary" fontWeight="bold">
                            {item.horafinstring}
                        </MDTypography>
                    </MDBox>
                    {/* Contenido principal */}
                    <MDBox flex={1} ml={2}>
                        {/* Descripción */}
                        <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            color={tramo?.some(x => x.id_Tramo === item.id_Tramo) ? 'primary' : 'text.primary'}
                        >
                            {item.descripcion}
                        </MDTypography>

                        {/* Plazas disponibles */}
                        {item.pax > 1 && (
                            <MDTypography variant="caption" color="text.secondary">
                                {(item.cantidadDisponible < 0 ? 0 : item.cantidadDisponible)} plazas disponibles
                            </MDTypography>
                        )}                       
                        {/* Precios visuales */}
                        <MDBox mt={1.5} display="flex" gap={1} flexWrap="wrap">
                            {PrecioInicial > 0 && (<MDBox
                                display="flex"
                                alignItems="center"
                                px={3}
                                py={0.75}
                                border={1}
                                borderRadius="lg"
                                sx={{
                                    backgroundColor: disable ? 'grey' : ( PrecioInicialDisabled ? 'white' : '#FF6F61'),
                                    color: PrecioInicialDisabled ? 'grey' : '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                {PrecioInicialDisabled ? "" : <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon>}
                                {PrecioInicial + " €"}
                            </MDBox>)}
                            {instalacion.tipo == TiposInstalacionReserva.Horaria ? "" :
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    px={3}
                                    py={0.75}
                                    borderRadius="lg"
                                    sx={{
                                        backgroundColor: disable ? 'grey' : (PrecioInicialDisabled || PrecioFinal <= 0 ? '#FF6F61' : '#2196f3'),
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                    }}
                                >
                                    {PrecioInicialDisabled || PrecioFinal <= 0 ? <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon> : <Icon sx={{ fontSize: 18, mr: 1 }}>discount</Icon>}
                                    {PrecioFinal > 0 ? PrecioFinal + " €" : "Free"}
                                </MDBox>}
                        </MDBox>
                    </MDBox>                    
                </Card>                
            </MDBox>
        </Grid>;
    }
   
    function CustomTooltip({ item, children })
    {
        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(item);              
        
        return (
            <Tooltip
                title={
                    <MDBox>
                        <MDBox sx={{ p: 1 }}>
                            <MDTypography variant="subtitle2" fontWeight="bold">
                                {item.descripcion}
                            </MDTypography>
                            <MDTypography variant="subtitle2" >
                                {item.infoPrecios}
                            </MDTypography>                            
                        </MDBox>
                        {instalacion.tipo == TiposInstalacionReserva.Horaria ? "" :
                            <MDBox
                                sx={{
                                    bgcolor: "#ef2c3c",
                                    color: "white",
                                    px: 2,
                                    py: 1,
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    fontSize: 13,
                                }}
                            >
                                <MDTypography variant="body2" color="white">
                                    Precio: {PrecioFinal + "€"}
                                </MDTypography>
                            </MDBox>}
                    </MDBox>
                }
                arrow
                placement="top"
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#f5f5f9',
                            color: '#000',
                            border: '1px solid #dadde9',
                            boxShadow: 3,
                            borderRadius: 2,
                            maxWidth: 220,
                           fontSize: '0.875rem',
                        },
                    },
                    arrow: {
                        sx: {
                            color: '#f5f5f9',
                        },
                    },
                }}
            >
                {children}
            </Tooltip>
        );           
    }       

    function renderSelecionTramoGrafico(rowindex, colindex, item, widthfinal, heightfinal, tipo) {
        let res = '';
        let backColor = '#ffffff';        

        if (item != null) {
            res = item.descripcion;
            backColor = item.cantidadDisponible <= 0 ? '#f5427e' : '#42f56f';

            if (tramo != null && tramo.some(x => x.id_Tramo === item.id_Tramo)) {
                backColor = '#2abce8';
            }
        }

        const content = (
            <div
                id={`${rowindex}${colindex}`}
                onClick={item != null && item.cantidadDisponible > 0 ? () => onClickTramoReserva(item, 1) : null}
                style={{
                    marginBottom: 1,
                    marginRight: 1,
                    width: widthfinal,
                    height: heightfinal,
                    border: item != null ? '1px solid gray' : '',
                    backgroundColor: item != null ? backColor : null,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: tipo == TipoGraficoInstalaciones.Circulo ? '50%' : 4,
                    cursor: item != null && item.cantidadDisponible > 0 ? 'pointer' : 'default',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={item != null ? e =>{
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                } : null }
                onMouseLeave={item != null ? e => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                } : null}
            >
                <strong>{res}</strong>
            </div>
        );

        return item != null ? (
            <CustomTooltip item={item}>
                {content}
            </CustomTooltip>
        ) : (
            content
        );
    }

    function renderItemOpcionHoraria(index, horas, precioHora, precio24Horas, es24Horas, esCustom)
    {
        let precioFinal = es24Horas ? precio24Horas : horas * precioHora;

        //Si el precio hora es
        if (precio24Horas < precioFinal)
            precioFinal = precio24Horas;

        let shadow = true;

        return (<Grid item xs={12} md={6} lg={3}>
            <MDBox m={0} >
                <Card sx={{
                    display: 'flex', flexDirection: 'column',
                    border: tramo?.some(x => x.horas === horas)
                        ? '2px solid #1a73e8'
                        : '1px solid #e0e0e0',
                    boxShadow: (theme) => (shadow ? theme.boxShadows.lg : 'none'),                  
                    borderRadius: 2,
                    cursor:  'pointer',
                    opacity:  1,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow:  12,
                        transform: 'scale(1.01)',
                    },
                }} onClick={() => onClickHorarioTramoReserva(es24Horas ? 24 : horas, precioFinal)}>
                    {/* Fila superior: imagen + info */}
                    <MDBox sx={{ display: 'flex' }} p={1}>                       
                        {/* Texto a la derecha */}
                        <MDBox sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }} mr={2} ml={2}>                            
                            <MDTypography variant="subtitle1" color="text.secondary" component="div">
                                Reserva {horas} {horas>1? "horas" : "hora" }
                            </MDTypography>                            
                        </MDBox>
                    </MDBox>
                    {/* Fila inferior: precio y botón */}
                    <MDBox
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1px solid #e0e0e0',
                            backgroundColor: '#fafafa',
                            px: 2,
                            py: 1.5,
                            pl: 2
                        }}
                    >
                        <MDBox display="flex" gap={1} flexWrap="wrap">
                            <MDBox
                                display="flex"
                                alignItems="center"
                                px={2}
                                py={0.75}
                                borderRadius="lg"
                                sx={{
                                    backgroundColor: '#FF6F61',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon>
                                {precioFinal + "€"}
                            </MDBox>
                        </MDBox>                        
                    </MDBox>
                </Card>
            </MDBox>
        </Grid>);


    }

    function renderOpcionesInstalacionHoraria(tamoselected)
    {
        if (tamoselected != null && tamoselected.itemsHoraria != null && tamoselected.itemsHoraria>0)
        {       
            let itemsOpciones = [];
            let horasReservar = 0;

            for (var i = 0; i < tamoselected.itemsHoraria; i++) {
                horasReservar += tamoselected.periocidadHoraria;

                let opcion = renderItemOpcionHoraria(0, horasReservar, tamoselected.precioHora, tamoselected.precio, false, false)

                if (opcion != null && opcion != "")
                    itemsOpciones.push(opcion);
            }

            //Si tenemos que mostra el 24horas
            if (tamoselected.item24horas == 1)
                itemsOpciones.push(renderItemOpcionHoraria(tamoselected.itemsHoraria + 1, 24, tamoselected.precioHora, tamoselected.precio, true, false));

            //if (tamoselected.opcionAnyHora == 1)
            //    itemsOpciones.push(renderItemOpcionHoraria(tamoselected.itemsHoraria + 2, horasReservar, tamoselected.precioHora, tamoselected.precio, false, true));

               
            return <>
                <Grid container mt={3}>
                 <MDTypography variant="h5" fontWeight="bold">
                        Seleccione la duracion de la reserva
                </MDTypography>
                </Grid>
                <Grid container spacing={3} mt={1}>
                    {itemsOpciones}
                </Grid>
            </>
        }
        else return "";
    }

    function renderSelecionTramos() {

        if (tramosdispo != null) {
            //Si tiene alguna actividad los montamos
            if (tramosdispo.length > 0) {
                let botonContinuar = tramo != null && tramo.length > 0 ?
                    <MDBox ml={0} mr={0} mt={3} mb={2}>
                        <Button fullWidth round color={"primary"} onClick={() => onClickTramoContinuar(tramo[0])}>Continuar Reserva</Button>
                    </MDBox> : "";

                let opcionesInstalacionHoraria = "";

                //Si estamos en modo horario y ya el cliente ha selccionado un tramo, le pongo las opciones disponibles (horas por contratar)
                if (instalacion.tipo == TiposInstalacionReserva.Horaria && tramo != null && tramo.length > 0)
                    opcionesInstalacionHoraria = renderOpcionesInstalacionHoraria(tramo[0]);


                //VISALIZACION GRAFICA
                if (InstalacionVisualiazacionGrafica())
                {
                    let tipoGraficoFinal = TipoGraficoInstalaciones.Cuadrado;
                    let widthfinal = widthfilas;
                    let heightfinal = heightfilas;
                    let widthBackGrafico = 1270;
                    let heightBackGrafico = 1680;
                    let ImageGraficoFinal = "";
                    
                    if (instalacion != null)
                    {
                        if (instalacion.imageGrafico != null)
                            ImageGraficoFinal = instalacion.imageGrafico;

                        if (instalacion.tipoGrafico != null )
                            tipoGraficoFinal = instalacion.tipoGrafico;

                        if (instalacion.widthGrafico != null && instalacion.widthGrafico > 0)
                            widthfinal = instalacion.widthGrafico;

                        if (instalacion.heightGrafico != null && instalacion.heightGrafico > 0)
                            heightfinal = instalacion.heightGrafico;

                        if (instalacion.widthImgGrafico != null && instalacion.widthImgGrafico > 0)
                            widthBackGrafico = instalacion.widthImgGrafico;

                        if (instalacion.heightImgGrafico != null && instalacion.heightImgGrafico > 0)
                            heightBackGrafico = instalacion.heightImgGrafico;
                    }

                    let finales = [];
                    let linea = [];

                    let rowfinal = 0;
                    let colfinal = 0;

                    tramosdispo.forEach(x => {
                        if (x.row != null && x.row > rowfinal)
                            rowfinal = x.row;

                        if (x.col != null && x.col > colfinal)
                            colfinal = x.col;
                    });

                    let NumDisponibles = 0;
                    let NumReservados = 0;

                    for (var row = 0; row <= rowfinal; row++) {
                        linea = [];

                        for (var col = 0; col <= colfinal; col++) {

                            var data = tramosdispo.find(x => x.col == col && row == x.row);

                            if (data != null)
                            {
                                if (data.cantidadDisponible == 0)
                                    NumReservados = NumReservados + 1;
                                else
                                    NumDisponibles += 1;
                            }

                            linea.push(renderSelecionTramoGrafico(row, col, data, widthfinal, heightfinal, tipoGraficoFinal ));
                        }                                                         

                        if (linea != null && linea.length > 0) {
                            var maxwidth = (colfinal * widthfinal) + 30 + 100;
                            finales.push(<Grid container style={{ marginLeft: 30, width: maxwidth }} >{linea}</Grid>);
                        }
                    } 

                    return <MDBox p={2} width="100%">
                        <Grid item xs={12}>

                            {/* Cabecera fija */}
                            <MDBox
                                mb={2}
                                px={2}
                                py={3}
                                borderRadius="lg"
                                bgColor="#f9f9f9"
                                border="1px solid #ddd"
                            >
                                <MDTypography variant="h5" fontWeight="bold" mb={2}>
                                    Situación Actual
                                </MDTypography>
                                <MDBox sx={{ display: 'flex', gap: 2 }} ml={1}>
                                    <Paper
                                        elevation={3}
                                        sx={{
                                            backgroundColor: '#42f56f',
                                            color: green[800],
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            minWidth: 120,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <MDTypography variant="body2" fontSize={16}>Disponibles</MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold">{NumDisponibles}</MDTypography>
                                    </Paper>

                                    <Paper
                                        elevation={3}
                                        sx={{
                                            backgroundColor: '#f5427e',
                                            color: blue[700],
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            minWidth: 120,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <MDTypography variant="body2" fontSize={16}>Reservados</MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold">{NumReservados}</MDTypography>
                                    </Paper>
                                </MDBox>
                            </MDBox>

                            {/* Zona scrollable con fondo + items */}
                            <MDBox
                                sx={{
                                    width: '100%',
                                    maxHeight: heightBackGrafico,
                                    overflow: 'auto',
                                    borderRadius: 2,
                                }}
                            >
                                <MDBox
                                    bgColor="#f9f9f9"
                                    sx={{
                                        width: widthBackGrafico,
                                        height: heightBackGrafico,
                                        backgroundImage: `url(${ImageGraficoFinal})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        position: 'relative',                                        
                                    }}
                                >
                                    <MDBox sx={{ px: 2, py: 2 }}>
                                        {finales}
                                    </MDBox>
                                </MDBox>
                            </MDBox>

                            {/* Botón fijo abajo */}
                            <MDBox mt={2}>
                                {opcionesInstalacionHoraria}
                                {botonContinuar}
                            </MDBox>
                        </Grid>
                    </MDBox>


                }
                else {
                    let final = tramosdispo.map(x => renderSelecionTramo(x));
                    return <MDBox p={2} width="100%">
                        <Grid container spacing={3}>{final}</Grid>
                        {opcionesInstalacionHoraria}
                        {botonContinuar}
                    </MDBox>;
                }
            }
            else {
                return <MDBox width="100%" textAlign="center" p={3}>
                    <MDTypography variant="h6" fontWeight="regular" color="error" mt={2} mb={2}>
                        No hay opciones disponibles
                    </MDTypography>
                </MDBox>;
            }
        }
        else
            return "";
    }

    function renderSeleccionPlazas(tramoseleccionado) {
        let tramoselected = null;
        

        if (tramosdispo != null && tramosdispo.length > 0)
            tramoselected = tramosdispo.find(y => y.id_Tramo == tramoseleccionado.id_Tramo);

        if (tramoselected != null) {
            let maxplaza = tramoselected.cantidadDisponible < tramoselected.maxPaxReservar ? tramoselected.cantidadDisponible : tramoselected.maxPaxReservar;
            let disable = maxplaza <= 0;

            let variosPrecios = tramoselected.precio > 0 && (tramoselected.precioReducido > 0 || tramoselected.conPrecioCero == 1);

            let valplaza = [];
            for (var i = 1; i <= maxplaza; i++)
                valplaza.push({ valor: i, name: i + (i == 1 ? " plaza" : " plazas") });

            let valplazaOtras = [];
            for (var i = 0; i <= maxplaza; i++)
                valplazaOtras.push({ valor: i, name: i + (i == 1 ? " plaza" : " plazas") });


            return <Grid item xs={12}>
                <MDBox ml={2} px={2} py={3} borderRadius="lg" bgColor="#f9f9f9" border="1px solid #ddd">
                    <MDTypography variant="h5" fontWeight="bold" mb={2}>
                        Selecciona el número de personas
                    </MDTypography>
                    <Grid container spacing={2}>
                        {/* Tarifa Normal */}
                        <Grid item xs={12} sm={variosPrecios ? 4 : 12}>
                            <MDBox p={2} border="1px solid #ccc" borderRadius="md" bgColor="white">
                                <MDTypography variant="subtitle2" color="text" mb={1}>
                                    Tarifa Normal
                                </MDTypography>
                                <OthelloComboBox fieldname="plazas" items={valplaza} currentvalue={1} />
                            </MDBox>
                        </Grid>

                        {/* Tarifa Reducida */}
                        {tramoselected.precioReducido > 0 && (
                            <Grid item xs={12} sm={variosPrecios ? 4 : 12}>
                                <MDBox p={2} border="1px solid #ccc" borderRadius="md" bgColor="white">
                                    <MDTypography variant="subtitle2" color="info.main" mb={1}>
                                        Tarifa Reducida
                                    </MDTypography>
                                    <OthelloComboBox fieldname="plazasReducidas" items={valplazaOtras} currentvalue={0} />
                                </MDBox>
                            </Grid>
                        )}

                        {/* Gratuidades */}
                        {tramoselected.conPrecioCero === 1 && (
                            <Grid item xs={12} sm={variosPrecios ? 4 : 12}>
                                <MDBox p={2} border="1px solid #ccc" borderRadius="md" bgColor="white">
                                    <MDTypography variant="subtitle2" color="success.main" mb={1}>
                                        Gratuidades
                                    </MDTypography>
                                    <OthelloComboBox fieldname="plazasGratuitas" items={valplazaOtras} currentvalue={0} />
                                </MDBox>
                            </Grid>
                        )}
                    </Grid>

                    {/* Máximo plazas */}
                    {(tramoselected.precioReducido > 0 || tramoselected.conPrecioCero === 1) && (
                        <MDBox mt={3}>
                            <Alert severity="info" variant="outlined" sx={{ borderRadius: 2 }}>
                                Máximo de plazas disponibles: <strong>{maxplaza}</strong>
                            </Alert>
                        </MDBox>
                    )}

                    {/* Info de precios */}
                    {tramoselected.infoprecios && (
                        <MDBox mt={3} p={2} borderRadius="md" bgColor="#fff3e0" border="1px solid #ffe0b2">
                            <MDTypography variant="body2" color="text" fontWeight="medium">
                                {tramoselected.infoPrecios}
                            </MDTypography>
                        </MDBox>
                    )}

                    {/* Botón */}
                    <MDBox mt={4}>
                        <Button
                            fullWidth
                            disabled={disable}
                            variant="contained"
                            color={disable ? "secondary" : "primary"}
                            onClick={() => onClickPlazasReserva(maxplaza)}
                            size="large"
                        >
                            Seleccionar
                        </Button>
                    </MDBox>
                </MDBox>
            </Grid>
        }
        else
            return "Error, consulte con nostros"        
    }

    function renderPax(indexpax, tipo, opcionesActivas, esomitible) {
        let idpax = tipo + "_" + indexpax + "_";

        let plazaname = "";

        if (tipo == 'E')
            plazaname = "Plaza ";
        else if (tipo == 'R')
            plazaname = "Reducida ";
        else if (tipo == 'G')
            plazaname = "Gratuita ";

        plazaname = plazaname + (indexpax + 1);

        //Obtenemos si debemos ocultar la lines de la persona
        let ocultar = paxomitidos != null && paxomitidos.some(x => x == (idpax + "omitir"));

        return <>
            <Grid item xs={12}>
                <MDBox ml={0} px={2} py={3} mb={2} borderRadius="lg" bgColor="#f9f9f9" border="1px solid #ddd">
                    <MDTypography variant="h5" fontWeight="bold" mb={2}>
                        {plazaname}
                    </MDTypography>
                    <MDBox p={2} border="1px solid #ccc" borderRadius="md" bgColor="white">                                                        
                        {esomitible ? <Grid item xs={4} sm={3} md={2} lg={1}>
                            <OthelloCheckBox label={"Omitir " + plazaname} fieldname={idpax + "omitir"} checked={ocultar} onChange={OnCheckedChangeOmitirPax} />
                        </Grid> : ""}
                        {ocultar ? "" :
                            <>
                            <Grid container>
                                <input id={idpax + "tipo"} name={idpax + "tipo"} type="hidden" value={tipo} />
                                <input id={idpax + "indexpax"} name={idpax + "indexpax"} type="hidden" value={indexpax} />
                                {opcionesActivas.indexOf(OpcionesNominaciones.Nombre) >= 0 ?
                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Nombre (*)" fieldname={idpax + "N"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Apellidos) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Apellidos (*)" fieldname={idpax + "A"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.DNI) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Documento Identidad (*)" fieldname={idpax + "D"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Sexo) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Sexo (H-M) (*)" fieldname={idpax + "G"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Edad) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Edad (*)" fieldname={idpax + "O"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.FechaNacimiento) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloTimer label="Fecha de Nacimiento (*)" fieldname={idpax + "F"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Telefono) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Telefono (*)" fieldname={idpax + "T"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Email) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Email (*)" fieldname={idpax + "E"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Club) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Club (*)" fieldname={idpax + "C"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Direccion) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Direccion (*)" fieldname={idpax + "C"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.CodigoPostal) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="C.Postal (*)" fieldname={idpax + "L"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Procedencia) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Procedencia (*)" fieldname={idpax + "P"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Talla) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Talla (*)" fieldname={idpax + "S"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.NumRegistroSanitario) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Nº Registro Sanitario (*)" fieldname={idpax + "M"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Curso) >= 0 ?

                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloEdit label="Curso (*)" fieldname={idpax + "Y"} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.Madrugadores) >= 0 ?
                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloComboBox label='Opcion Madrugadores (*)' fieldname={idpax + "I"} items={OpcionSiNoStringLargo} />
                                    </Grid> : ""
                                }
                                {opcionesActivas.indexOf(OpcionesNominaciones.SabeNadar) >= 0 ?
                                    <Grid item xs={6} sm={4} md={2} lg={2}>
                                        <OthelloComboBox label='Sabe Nadar (*)' fieldname={idpax + "H"} items={OpcionSiNoStringLargo} />
                                    </Grid> : ""
                                }
                            </Grid>
                            <Grid container >
                                    <Grid item xs={12} >                                       
                                        {errornominacion != null && errornominacion != "" ? 
                                            <MDBox mt={2}>
                                                <Alert
                                                    severity="error"
                                                    variant="outlined"
                                                    sx={{
                                                        fontSize: "0.9rem",
                                                        color: "error.main",
                                                        borderColor: "error.light",
                                                        backgroundColor: "#fff8e1",
                                                        paddingY: 1,
                                                        paddingX: 2,
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    {errornominacion}
                                                </Alert>
                                            </MDBox>
                                        : ""}
                                </Grid>
                            </Grid>
                        </>}            
                    </MDBox>
                </MDBox>
            </Grid>
        </>;
    }

    function EsPaxOmitible(currentindex) {

        //Es omitobles si no es obligatorio nominar todas o si no lo es no estamos en la primer plaza
        return instalacion.obligatorioNominarTodasPax == 0 && currentindex != 0;

    }

    function renderNominarPax() {

        let paxNomina = [];

        var indexpax = 0;

        if (plazas != null && plazas > 0) {
            for (var i = 0; i < plazas; i++) {
                paxNomina.push(renderPax(indexpax, "E", instalacion.opcionesNominacion, EsPaxOmitible(indexpax)));
                indexpax = indexpax + 1;
            }
        }

        if (plazasReducidas != null && plazasReducidas > 0) {
            for (var i = 0; i < plazasReducidas; i++) {
                paxNomina.push(renderPax(indexpax, "R", instalacion.opcionesNominacion, EsPaxOmitible(indexpax)));
                indexpax = indexpax + 1;
            }
        }

        if (plazasGratuitas != null && plazasGratuitas > 0) {
            for (var i = 0; i < plazasGratuitas; i++) {
                paxNomina.push(renderPax(indexpax, "G", instalacion.opcionesNominacion, EsPaxOmitible(indexpax)));
                indexpax = indexpax + 1;
            }
        }

        return <MDBox mt={0} ml={3} mb={1} mr={2} width="100%">
            <Grid container>
                <Grid item xs={12}>
                    <form id="formnominacionpax">
                        {paxNomina}
                        <MDBox mt={4}>
                            <Button
                                fullWidth                               
                                variant="contained"
                                color="primary"
                                onClick={() => onClickNominadasPlazasReserva()}
                                size="large"
                            >
                                Continuar Reserva
                            </Button>
                        </MDBox>
                    </form>
                </Grid>
            </Grid>
        </MDBox>;
    }   

    function renderAutorizacionPax(indexpax) {
        let idpax = "P_" + indexpax + "_";

        let plazaname = "Autorizacion " + (indexpax + 1);

        return <>           
            <MDBox width='100%' display="flex" justifyContent="space-between" bgColor="secondary" mt={3} py={0.5} px={2}  borderRadius="sm">
                <MDTypography variant="h6" mt={1} fontWeight="light" color="white" height={32}>{plazaname}</MDTypography>
                <MDBox>
                    {(indexpax + 1) == paxautoriza ? <Button iconOnly color="light" onClick={() => onClickAddAutorizacion()}><Add /></Button> : ""}
                    {(indexpax + 1) == paxautoriza && paxautoriza > 1 ? <Button iconOnly color="light" onClick={() => onClickDeleteAutorizacion()}><Delete /></Button> : ""}
                </MDBox>
            </MDBox>
            <input id={idpax + "indexpax"} name={idpax + "indexpax"} type="hidden" value={indexpax} />
            <Grid container>
                <Grid item xs={8} sm={8}>
                    <OthelloEdit label="Nombre y Apellidos (*)" fieldname={idpax + "A"} />
                </Grid>
                <Grid item xs={4} sm={4}>
                    <OthelloEdit label="DNI (*)" fieldname={idpax + "B"} />
                </Grid>
            </Grid>           
        </>;
    }

    function renderAutorizacion() {

        let paxAutoriza = [];        

        if (paxautoriza != null && paxautoriza > 0)
        {
            for (var i = 0; i < paxautoriza; i++)
                paxAutoriza.push(renderAutorizacionPax(i));                            
        }
       
        return <MDBox mt={0} ml={3} mb={1} mr={2} width="100%">
            <Grid container>
                <Grid item xs={12}>
                    <form id="formautorizacion">
                        <MDBox ml={0} px={2} py={3} mb={2} borderRadius="lg" bgColor="#f9f9f9" border="1px solid #ddd">
                            <MDTypography variant="h5" fontWeight="bold" mb={2}>
                                Autorizaciones
                            </MDTypography>                        
                            <Grid container>                           
                                <Grid item xs={12} sm={6} md={3} >
                                    <OthelloEdit label="D/Dña (*)" fieldname="NombreApellidosAutoriza" />
                                </Grid>
                                <Grid item xs={6} sm={4} md={2}>
                                    <OthelloEdit label="con Documento (*)" fieldname="DNIAutoriza" />
                                </Grid>
                                <Grid item xs={6} sm={4} md={3}>
                                    <OthelloEdit label="Telefono/s (*)" fieldname="TelefonoAutoriza" />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} >
                                    <OthelloEdit label="AUTORIZO como padre, madre, tutor/a legal del niño/a  (*)" fieldname="AutorizoComo" />
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12} ml={1} my={1}>
                                    {TratarTexto(instalacion.textoAutorizaciones)}
                                </Grid>
                            </Grid>
                            {paxAutoriza}
                            <Grid container >
                                <Grid item xs={12} >
                                    {errorautorizacion != null && errorautorizacion != "" ?                                     
                                            <MDBox mt={2}>
                                                <Alert
                                                    severity="error"
                                                    variant="outlined"
                                                    sx={{
                                                        fontSize: "0.9rem",
                                                        color: "error.main",
                                                        borderColor: "error.light",
                                                        backgroundColor: "#fff8e1",
                                                        paddingY: 1,
                                                        paddingX: 2,
                                                        alignItems: "center"
                                                    }}
                                                >
                                                {errorautorizacion}
                                                </Alert>
                                            </MDBox>
                                         : "" }
                                </Grid>
                            </Grid>
                            <MDBox mt={3} mr={1} >
                                <Button fullWidth color="primary" onClick={() => onClickAutorizaciones()}>Continuar Reserva</Button>
                            </MDBox>
                        </MDBox>
                    </form>
                </Grid>
            </Grid>
        </MDBox>;       
    }

    const renderExtra = (item) => {

        const hasImage = item?.image && item.image.trim() !== "";
        let CantidadSelected = 1;
        let EstaSeleccionado = false;

        if (extraselected != null && extraselected.length>0 && extraselected.some(x => x.id_Extra == item.id_Extra)) {
            let selected = extraselected.find(x => x.id_Extra == item.id_Extra);
            if (selected != null) {
                CantidadSelected = selected.cantidad;
                EstaSeleccionado = true;
            }
        }

        var Normales = Number(plazas);
        var Reducidas = Number(plazasReducidas);
        var Gratuitas = Number(plazasGratuitas);

        var TotalPlazas = Normales + Reducidas + Gratuitas;

        if (item.tipoExtra === TipoExtraInstalaciones.Libre || item.tipoExtra === TipoExtraInstalaciones.Entradas)
            TotalPlazas = 20;

        let valoresCombo = [];
        for (var i = 1; i <= TotalPlazas; i++)
            valoresCombo.push({ valor: i, name: i });

        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(item);

        return (<Grid item xs={12} md={6} lg={3}>
            <MDBox m={1} >
                <Card sx={{ display: 'flex', flexDirection: 'column', }}>
                    {/* Fila superior: imagen + info */}
                    <MDBox sx={{ display: 'flex' }} p={1}>
                        {/* Imagen izquierda */}
                        <MDBox
                            sx={{
                                width: 120,
                                height: 120,
                                mr: 2,
                                borderRadius: 2,
                                backgroundImage: hasImage ? `url(${item.image})` : 'none',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundColor: hasImage ? 'transparent' : '#f0f0f0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {!hasImage && renderGetIcono(-1)}
                        </MDBox>

                        {/* Texto a la derecha */}
                        <MDBox sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }} mr={2}>
                            <MDTypography component="div" variant="h6">
                                {item.codigo}
                            </MDTypography>
                            <MDTypography variant="subtitle1" color="text.secondary" component="div">
                                {item.descripcion}
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary" mt={1}>
                                {item.infoAdicional}
                            </MDTypography>
                        </MDBox>
                    </MDBox>                  
                    {/* Fila inferior: precio y botón */}
                    <MDBox
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1px solid #e0e0e0',
                            backgroundColor: '#fafafa',
                            px: 2,
                            py: 1.5,
                            pl: 2
                        }}
                    >                        
                        <MDBox display="flex" gap={1} flexWrap="wrap">
                            <MDBox
                                display="flex"
                                alignItems="center"
                                px={2}
                                py={0.75}
                                borderRadius="lg"
                                sx={{
                                    backgroundColor: '#FF6F61',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon>
                                {PrecioFinal > 0 ? PrecioFinal + "€" : "Free"}
                            </MDBox>
                        </MDBox>                        
                        {/* Acción según tipo */}
                        <MDBox display="flex" alignItems="center" minHeight={60}>
                            {item.tipoExtra === TipoExtraInstalaciones.PorPax || item.tipoExtra === TipoExtraInstalaciones.Libre || item.tipoExtra === TipoExtraInstalaciones.Entradas ?
                                <MDBox border="1px solid #ccc" borderRadius="md" bgColor="white" mr={1} mt={0} pb={0.8} px={0.5}>
                                    <OthelloComboBox labelliteral="_cantidad" fieldname={"cantidad" + item.id_Extra} items={valoresCombo} currentvalue={CantidadSelected} disabled={EstaSeleccionado} />
                                </MDBox> : ""}
                            {EstaSeleccionado ? (
                                <>
                                    <MDBox display="flex" alignItems="center" color="green" mr={0.5}>
                                        <Icon sx={{ mr: 0.5 }}>check_circle</Icon>
                                        <MDTypography variant="body2">Añadido</MDTypography>
                                    </MDBox>
                                    <Button color="error" iconOnly onClick={() => handleEliminarExtraReserva(item)}>
                                        <Icon>delete</Icon>
                                    </Button>
                                </>
                            ) :
                                <Button variant="contained" color="success" onClick={() => handleAddExtraReserva(item)}>
                                    Añadir
                                </Button>
                            }
                        </MDBox>
                    </MDBox>                   
                </Card>
            </MDBox>
        </Grid>);
    }

    function renderExtrasReserva() {

        if (loadingextras)
            return "Buscando extras, un momento por favor..."
        else
        {
            let finales = extrasdispo != null && extrasdispo.length > 0 ? extrasdispo.map(x => renderExtra(x)) : "";

            return <>
                {finales}
                <Grid container justifyContent="center" mt={2}>
                    <Grid item xs={12} mx={1}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() => onClickAceptarExtras()}
                            sx={{ borderRadius: 2, textTransform: 'none',  }}
                        >
                            Continuar Reserva
                        </Button>
                    </Grid>
                </Grid>
                <Grid container >
                    <Grid item xs={12} >
                        {errorextras != null && errorextras != "" ?
                            <MDBox mt={2}>
                                <Alert
                                    severity="error"
                                    variant="outlined"
                                    sx={{
                                        fontSize: "0.9rem",
                                        color: "error.main",
                                        borderColor: "error.light",
                                        backgroundColor: "#fff8e1",
                                        paddingY: 1,
                                        paddingX: 2,
                                        alignItems: "center"
                                    }}
                                >
                                    {errorextras}
                                </Alert>
                            </MDBox>
                            : ""}
                    </Grid>
                </Grid>
               </>;
        }
    }

    function ResumenReservaMUI(conceptosResumenPrecio, total) {

        let porconcepto = [];

        if (conceptosResumenPrecio != null && conceptosResumenPrecio.length > 0)
        {
            porconcepto = conceptosResumenPrecio.map(x => <MDBox sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <MDTypography variant="caption" fontSize={15} >{x.descripcion}</MDTypography>
                <MDTypography variant="caption" color="text.secondary" fontSize={15} sx={{ textAlign: 'right', minWidth: '60px' }}>
                    {x.total.toFixed(2)} €
                </MDTypography>
            </MDBox>)
        }

        return (
            <MDBox>                
                {porconcepto }              
                <Divider sx={{ my: 1 }} />
                <MDBox sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: blue[500],
                    fontWeight: 'bold',
                }}>
                    <MDTypography variant="body2" fontWeight="bold">Total</MDTypography>
                    <MDTypography variant="body2" fontWeight="bold" sx={{ textAlign: 'right', minWidth: '60px' }}>
                        {total.toFixed(2)} €
                    </MDTypography>
                </MDBox>
            </MDBox>
        );
    }

    function renderDatosReserva(user)
    {      
        //Obtenemos el precio       
        var Totales = getResumenTotalesReservaSegunSituacion();          

        var franja = "";
        let ids = [];
        let horas = 0;

        tramo.forEach(x => {
            franja = franja + x.descripcion + " - ";
            ids.push(x.id_Tramo);
            horas = x.horas;
        });

        

        // estoy aqui controlando que la cantida final es la correcta, que el precio es el bueno, y tendria que controlar que la cantidad de maximas disponible es correcta cuando estan metiendo las plazas en el paso concreto        

        return <Grid item xs={12}>          
            <MDBox p={2}>
            <Grid container spacing={2} >
                {/* BLOQUE IZQUIERDO */}
                <Grid item xs={12} md={8}>
                    {/* Card: Resumen de Reserva */}
                    <Card variant="outlined" sx={{ mb: 3, backgroundColor: "#f9f9f9" }} >
                        <CardContent>
                            <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={1}>
                                Resumen de la Reserva
                            </MDTypography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <OthelloEdit label="Actividad" currentvalue={instalacion.descripcion} readonly />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <OthelloEdit label="Fecha" currentvalue={getfechaformateada(fecha)} readonly />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <OthelloEdit label="Franja" currentvalue={franja} readonly />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <OthelloEdit label="Plazas" currentvalue={Totales.totalplazas} readonly />
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <OthelloEdit label="Dirección" currentvalue={instalacion.direccion} readonly />
                                </Grid>
                                {instalacion.latstring !== "0" && (
                                    <Grid item xs={12}>
                                        <Button                                            
                                            color="success"
                                            fullWidth
                                            href={`https://maps.google.com/?q=${instalacion.lat},${instalacion.lon}`}
                                            target="_blank"
                                        >
                                            Ver en Mapa
                                        </Button>
                                    </Grid>
                                )}                               
                            </Grid>
                        </CardContent>
                    </Card>
                    {/* Card: Datos de Contacto */}
                    <Card variant="outlined" sx={{ mb: 3 }}>
                        <CardContent>
                            <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={1}>
                                Datos de Contacto
                                </MDTypography>
                                <form id="formreserva">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <OthelloEdit variant="outlined"
                                                label={modoExterno ? "Nombre y Apellidos (*)" : "Contacto"}
                                                fieldname="Contacto"
                                                currentvalue={user != null ? `${user.nombre} ${user.apellido}` : ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <OthelloEdit variant="outlined"
                                                label={modoExterno ? "Email (*)" : "Email"}
                                                fieldname="EMail"
                                                currentvalue={user != null ? user.eMail : ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <OthelloEdit variant="outlined"
                                                label={modoExterno ? "Teléfono (*)" : "Teléfono"}                                                
                                                fieldname="Telefono"
                                                currentvalue={user != null ? user.telefono : ""}
                                            />
                                        </Grid>
                                        {!InstalacionOcultarCampoNumSocio() && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <OthelloEdit variant="outlined"                                                    
                                                    label={instalacion.literalCampoNumSocio || "Nº Socio"}
                                                    fieldname="NumSocio"
                                                            currentvalue={user != null ? user.numSocio : ""}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                                    <OthelloEdit variant="outlined"
                                                label="Comentarios o indicaciones"
                                                fieldname="Observaciones"
                                                rows={2}
                                            />
                                        </Grid>
                                    </Grid>
                                    <input type="hidden" name="Id_Usuario" value={user != null ? user.id_Usuario : -1} />
                                    <input type="hidden" name="Id_Instalacion" value={instalacion.id_Instalacion} />
                                    <input type="hidden" name="Id_Reserva" value={0} />
                                    <input type="hidden" name="ids_tramosmodel" value={ids} />
                                    <input type="hidden" name="Fecha" value={fecha} />
                                    <input type="hidden" name="Cantidad" value={Totales.totalplazas} />
                                    <input type="hidden" name="Precio" value={Totales.totalprecio} />
                                    <input type="hidden" name="Instalacion" value={instalacion.descripcion} />
                                    <input type="hidden" name="Tramo" value={franja} />
                                    <input type="hidden" name="ID_DriverPasarela" value={instalacion.iD_DriverPasarela} />
                                    <input type="hidden" name="ActivaPasarela" value={instalacion.activaPasarela} />
                                    <input type="hidden" name="InfoAdicionalPlazasPrecios" value={""} />
                                    <input type="hidden" name="DataNominacion" value={nominacionPax} />
                                    <input type="hidden" name="DataAutorizaciones" value={autorizaciones} />
                                    <input type="hidden" name="DataExtras" value={extraselected != null && extraselected.length > 0 ? JSON.stringify(extraselected) : ""} />
                                    <input type="hidden" name="DuracionHorariaRsv" value={horas} />                                    
                                    <input type="hidden" name="TimeMargenCheckOut" value={instalacion.timeAutoCheckout} />     
                                </form>

                                {/* Mensaje de advertencia */}

                                {/* Errores */}
                                {errorDatosContactoObligatorios && (
                                    <MDBox mt={2}>
                                        <Alert
                                            severity="error"
                                            variant="outlined"
                                            sx={{
                                                fontSize: "0.9rem",
                                                color: "error.main",
                                                borderColor: "error.light",
                                                backgroundColor: "#fff8e1",
                                                paddingY: 1,
                                                paddingX: 2,
                                                alignItems: "center"
                                            }}
                                        >
                                            {errorDatosContactoObligatorios}
                                        </Alert>                                       
                                    </MDBox>
                                )}
                            <MDBox mt={2}>
                                <Alert severity="warning" icon={false} sx={{ fontSize: "0.9rem" }}>
                                    Por favor, revisa que tus datos de contacto estén actualizados. Usaremos esta información para enviarte confirmaciones o avisos de la reserva.
                                </Alert>
                            </MDBox>                                
                        </CardContent>
                    </Card>                                     
                </Grid>
                {/* BLOQUE DERECHO: Precio + Imagen + Botones */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ position: "sticky", top: 80, p: 0 }}>
                        {instalacion.image && (
                            <img
                                src={instalacion.image}
                                alt="Instalación"
                                style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "cover",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px"
                                }}
                            />
                        )}
                        <CardContent>
                            <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={1}>
                                Resumen de precio
                                </MDTypography>
                                {ResumenReservaMUI(Totales.conceptosresumen, Totales.totalprecio)}
                            <Grid container spacing={1} mt={2}>                               
                                <Grid item xs={12}>
                                        <Button fullWidth variant="contained" color="primary" size="large" onClick={grabarReserva}>
                                        Reservar Ahora
                                    </Button>
                                </Grid>
                                </Grid>
                                {/* Toggle: aplicar código */}
                                <MDBox mt={2}>
                                    <MDTypography variant="body2"
                                        onClick={() => setShowCodigoDescuento(!showCodigoDescuento)}
                                        sx={{
                                            color: 'black',
                                            fontWeight: 400,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            userSelect: 'none',
                                        }}
                                    >                                    
                                        {showCodigoDescuento ? <ExpandLessIcon sx={{ mr: 1 }} /> : <ExpandMoreIcon sx={{ mr: 1 }} />}
                                        Aplicar código de descuento
                                    </MDTypography>

                                    <Collapse in={showCodigoDescuento}>
                                        <MDBox mt={2} display="flex" alignItems="center" gap={2} flexWrap="wrap">
                                            <TextField
                                                label="Código de descuento"
                                                size="small"
                                                variant="outlined"
                                                value={codigoDescuento}
                                                onChange={(e) => setCodigoDescuento(e.target.value)}
                                                error={errorCodigoDescuento}
                                            />
                                            <Button
                                                variant="contained"
                                                color="dark"
                                                onClick={handleAplicarCodigoDescuento}
                                                sx={{ height: '40px' }}
                                            >
                                                Aplicar
                                            </Button>
                                        </MDBox>
                                        {errorCodigoDescuento && (
                                            <MDTypography color="error" variant="body2" mt={1}>
                                                El código ingresado no es válido.
                                            </MDTypography>
                                        )}
                                    </Collapse>
                                </MDBox>
                        </CardContent>
                    </Card>
                </Grid>                
            </Grid>            
            {/* Textos adicionales */}
            <MDBox mt={3}>
                {getTextoInstalacion(instalacion, 1)}
                {getTextoInstalacion(instalacion, 0)}
            </MDBox>
                {getNavegacionPaso(pasoAtras)}
            </MDBox>
        </Grid>
    }

    function renderPagarReserva(user, pago) {

        let metodoRealizarPago = pago != null && pago.driver == "Paytef" ? doPagoPaytef : realizarPago;

        return getBotonPagarPasarelaPago(user != null ? user.id_Rol : null, pago, metodoRealizarPago);
        /*let formulariopago = "";

        
        let pagocontado = "";

        if (pago != null) {
            if (user != null && (user.id_Rol == Roles.SuperUsuario || user.id_Rol == Roles.Administrador))
            {
                pagocontado =
                    <Grid item xs={6} sm={6} pr={1}>
                    <Button fullWidth color="twitter" href={pago.urlokcontado }>Pago Contado</Button>
                    </Grid>
            } 

            //Si estamos con Paygold
            if (pago.driver == "RedSys") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver} method="post">
                    <input runat="server" type="hidden" id="Ds_SignatureVersion" name="Ds_SignatureVersion" value={pago.ds_SignatureVersionGold} /> 
                    <input runat="server" size="100" type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" value={pago.ds_MerchantParametersGold} />
                    <input runat="server" type="hidden" size="50" id="Ds_Signature" name="Ds_Signature" value={pago.ds_SignatureGold} />               
                        <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>                    
                </form></Grid>)
            }
            else if (pago.driver == "PayComet") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosComet} method="post">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid>)
            }
            else if (pago.driver == "AddOnPayments") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosAddOn} method="post">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid >);
            }
            else if (pago.driver == "CecaBank") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosCecabank} method="post" encType="application/x-www-form-urlencoded">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid>)
            }
        }
       
        return <Grid container xs={12} mt={1}>{formulariopago} {pagocontado}</Grid>;*/
    }

/*
    * <input type="hidden" id="MerchantID" name="MerchantID" value="111950028" />
               <input type="hidden" id="AcquireBIN" name="AcquireBIN" value="0000554052" />
               <input type="hidden" id="TerminalID" name="TerminalID" value="00000003" />
               <input type="hidden" id="URL_OK" name="URL_OK" value="http://www.ceca.es" />
               <input type="hidden" id="URL_NOK" name="URL_NOK" value="http://www.ceca.es" />
               <input type="hidden" id="Firma" name="Firma" value="2b7f686593f1a424c510321e4bc354d21924e02e980a90f4d46c41f92a06f5a9" />
               <input type="hidden" id="Cifrado" name="Cifrado" value="SHA2" />
               <input type="hidden" id="Num_operacion" name="Num_operacion" value="123" />
               <input type="hidden" id="Importe" name="Importe" value="500" />
               <input type="hidden" id="TipoMoneda" name="TipoMoneda" value="978" />
               <input type="hidden" id="Exponente" name="Exponente" value="1" />
               <input type="hidden" id="Pago_Soportado" name="Pago_Soportado" value="SSL" />
               <input type="hidden" id="Idioma" name="Idioma" value="1" />*/

    function renderTotalizadorReserva()
    {
        var Totales = getResumenTotalesReservaSegunSituacion();

        let textoNumSocio = "Reserva en nuestra web de manera sencilla";
        let InfoNumSocio = "Disfruta de un proceso de reserva ágil y sin intermediarios.";
        let visibleOpcionesSocio = false;

        if (instalacion != null && instalacion.activoNumSocio == 1)
        {
            if (instalacion.textoNumSocio != null && instalacion.textoNumSocio != "")
                textoNumSocio = instalacion.textoNumSocio;

            if (instalacion.infoNumSocio != null && instalacion.infoNumSocio != "")
                InfoNumSocio = instalacion.infoNumSocio;

            visibleOpcionesSocio = true;
        }        

        let totalizador = <MDBox
            sx={{
                position: 'sticky',
                bottom: 0,
                width: '100%',
                backgroundColor: '#f9fafb',
                borderTop: '1px solid #e0e0e0',
                boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.06)',
                py: 2,
                px: { xs: 1, sm: 1, md: 1 },
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                zIndex: 1100,
                gap: 2,
            }}
        >
            {/* Sección destacada */}
            <Paper
                elevation={0}
                sx={{
                    border: '1px solid #1976d2',
                    borderRadius: 1,
                    backgroundColor: '#ffffff',
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 3,
                    flex: {
                        xs: '1 1 100%', // Pantallas pequeñas: 100%                        
                        md: '1 1 85%',  // A partir de md: 75%
                    },
                    flexWrap: 'wrap',
                    minWidth: 0,
                }}
            >
                <MDBox>
                    <MDTypography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                        {textoNumSocio}
                    </MDTypography>
                    <MDTypography variant="body2">
                        {InfoNumSocio}
                    </MDTypography>
                </MDBox>

                <MDBox
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexGrow: 1,
                        justifyContent: 'flex-end',
                        minWidth: 150,
                        flexWrap: 'wrap',
                    }}
                >
                    {visibleOpcionesSocio ?
                    <><TextField
                        label={instalacion.literalCampoNumSocio ? instalacion.literalCampoNumSocio : "Indique Numero"}
                        variant="outlined"
                        size="small"
                        value={numeroSocio}
                        onChange={handleChangeNumero}
                        sx={{ minWidth: 100 }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={socioActivado}
                                onChange={handleToggle}
                                disabled={numeroSocio.trim() === ''}
                                color="success"
                            />
                        }
                        label="Activar descuento"
                    /></> : ""}
                </MDBox>
            </Paper>

            {/* Totalizador */}
            <Paper
                elevation={0}
                sx={{
                    border: '1px solid #1976d2',
                    borderRadius: 1,
                    backgroundColor: '#ffffff',
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    flex: {
                        xs: '1 1 100%', // Pantallas pequeñas: 100%                        
                        md: '1 1 10%',  // A partir de md: 25%
                    },
                    minWidth: 200,
                }}
            >
                <MDTypography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 500,
                        fontSize: '1.2rem',
                        color: '#374151',
                    }}
                >
                    Total:
                </MDTypography>
                <MDTypography
                    variant="h5"
                    sx={{
                        fontWeight: 'bold',
                        color: '#1976d2',
                    }}
                >
                    {Totales.totalprecio.toFixed(2)} €
                </MDTypography>
            </Paper>          
        </MDBox>

        return totalizador;
    }

    function renderPasosReserva() { 
        let paso1 = "";
        let paso2 = "";
        let paso3 = "";
        let paso4 = "";
        let paso5 = "";
        let paso6 = "";
        let paso7 = "";
        let paso8 = "";
        let paso9 = "";

        if (paso >= 1) {
            paso1 =
                <Grid container>
                    {getTituloPaso(1, paso)}
                    {paso == 1 ? renderInstalaciones( data) : ""}
                </Grid>
        }

        if (paso >= 2) {
            paso2 = <><Grid container>
                {getTituloPaso(2, paso, instalacion.descripcion)}
                {paso === 2 ? getNavegacionPaso(pasoAtras) : ""}                
                {paso == 2 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 2 ? renderSeleccionFechas() : ""}
                {paso == 2 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 2 ? getNavegacionPaso(pasoAtras) : ""}                
            </Grid></>
        }

        if (paso >= 3) {
            paso3 = <Grid container>
                {getTituloPaso(3, paso, fecha)}
                {paso === 3 ? getNavegacionPaso(pasoAtras) : ""}
                {paso == 3 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 3 ? renderSelecionTramos() : ""}
                {paso == 3 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 3 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 4 && InstalacionTieneSeleccionPax()) {
            paso4 = <Grid container>
                {getTituloPaso(4, paso)}
                {paso === 4 ? getNavegacionPaso(pasoAtras) : ""}
                {paso == 4 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 4 ? renderSeleccionPlazas(tramo[0]) : ""}
                {paso == 4 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 4 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 5 && instalacion != null && instalacion.nominarPax == 1) {

            paso5 = <Grid container>
                {getTituloPaso(5, paso)}
                {paso === 5 ? getNavegacionPaso(pasoAtras) : ""}
                {paso == 5 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 5 ? renderNominarPax() : ""}
                {paso == 5 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 5 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 6 && instalacion != null && instalacion.activaAutorizaciones == 1) {

            paso6 = <Grid container>
                {getTituloPaso(6, paso)}
                {paso === 6 ? getNavegacionPaso(pasoAtras) : ""}
                {paso == 6 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 6 ? renderAutorizacion() : ""}
                {paso == 6 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 6 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 7) {
            paso7 = <Grid container>
                {getTituloPaso(7, paso)}
                {paso === 7 ? getNavegacionPaso(pasoAtras) : ""}
                {paso == 7 ? getTextoInstalacion(instalacion, 1) : ""}
                {paso == 7 ? renderExtrasReserva() : ""}
                {paso == 7 ? getTextoInstalacion(instalacion, 0) : ""}
                {paso === 7 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 8) {
            paso8 = <Grid container>
                {getTituloPaso(8, paso)}
                {paso == 8 ? renderDatosReserva( props.user) : ""}
            </Grid>
        }

        if (paso >= 9) {
            paso9 = <Grid container>
                {getTituloPaso(9, paso)}
                <Grid item xs={12} mx={1}>
                    {TratarTexto("Pulse el botón de <strong> Realizar el pago</strong> para completar su reserva")}
                    {TratarTexto("<strong>ATENCIÓN:</strong> Las reservas sin pagar serán canceladas automáticamente si no se realiza el pago.")}                   
                </Grid>
                {paso == 9 ? <Grid item xs={12} >{renderPagarReserva(props.user, infopago)}</Grid> : ""}
            </Grid>
        }

        let totalreserva = paso > 1 ? renderTotalizadorReserva() : "";
       
        return (
            <Grid item xs={12}>
                {Boolean(data?.imagebannerreservas) && (
                    <Grid container>
                        <Grid item xs={12}>
                            <MDBox
                                component="img"
                                src={data.imagebannerreservas}
                                alt="Banner Reservas"
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: 150,
                                        sm: 180,
                                        md: 250,
                                        lg: 300,
                                        xl: 350
                                    },
                                    objectFit: 'cover',
                                    border: '0.5px solid #eeeeee',
                                    borderRadius: 1,
                                    mb: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                )}
                {totalreserva}
                <MDBox px={1}>
                    {paso1}
                    {paso2}
                    {paso3}
                    {paso4}
                    {paso5}
                    {paso6}
                    {paso7}
                    {paso8}
                    {paso9}
                </MDBox>
                <br />
            </Grid>
        );
    }

    function renderCargando()
    {
         return <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
                minHeight: 140,
                backgroundColor: "rgba(0, 0, 0, 0.6)",  // Fondo oscuro semi-transparente
                borderRadius: 2,
                padding: {
                    xs: "20px",  // Para dispositivos pequeños (móviles)
                    sm: "20px 40px",  // Para pantallas más grandes
                },
                boxShadow: 2,
                width: "100%", // Asegura que ocupe todo el ancho disponible
                position: "absolute", // Lo coloca sobre la imagen de fondo
                top: "50%", // Centrado verticalmente
                left: "50%",
                transform: "translate(-50%, -50%)", // Ajusta el centro
            }}
        >
            <CircularProgress color="secondary" size={50} sx={{ marginRight: 2 }} />
            <MDTypography variant="body1" color="white" fontWeight="400">
                Cargando...
            </MDTypography>
        </MDBox>
    }

    function renderModalFecha(valor) {
        return (<OthelloModalBase titulo="Seleccione Fecha" modo={ModoModal.SinDefinir} open={statefechaModal} onCloseResulModal={othelloModalResulFecha} botones={MessageOthelloBoxButtons.OK}>
            <OthelloTimer label="Fecha" fieldname="fbase" currentvalue={valor != null ? valor : ""} onChange={OnChangeFechaModal} />
        </OthelloModalBase>)
    }

    let formulario = loading ? renderCargando() : renderPasosReserva()

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    //Tratamos el tema del modal
    let modalfecha = "";

    //Si el estado del modal es distinto de cerrado
    if (statefechaModal != DataStateModal.dsClosed)
        modalfecha = renderModalFecha(fechashowvisuali);
   
    return <>               
        <Grid container>
        <Grid item xs={12} sm={12} md={12}>
            {alerta}
        </Grid>
        {modalfecha}
        {formulario}        
        <Grid item xs={12} sm={12} md={12}>
            <OthelloFooter />
            </Grid>            
        </Grid>
        {infoextraerror != "" ? infoextraerror : ""}
        {data != null && data.infoextraerrores != null && data.infoextraerrores != "" ? "-> "+ data.infoextraerrores : ""}
    </>
}

//propTypes = {
//    user: PropTypes.object,    
//    onResultReserva: PropTypes.object
//};